<template>
  <v-app id="product">
    <vue-topprogress ref="topProgress"></vue-topprogress>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      loader="dots"
      color="#007bff"
      :height="45"
      :width="75"
      :is-full-page="fullPage"
    ></loading>

    <v-row v-if="is_deleted == 1" justify="center" align="center">
      <v-col :cols="10">
        <v-alert dense outlined type="error">
          Product has been move to archieve section.To restore this product
          Please contact to administrator
        </v-alert></v-col
      >
    </v-row>
    <v-container>
      <v-row justify="center">
        <v-dialog v-model="companies_state_modal" persistent max-width="400">
          <v-card>
            <div>
              <v-card-title class="text-h4 pa-16" style="margin-top: -50px">
                <b>Do you still want to continue?</b>
              </v-card-title>
              <v-card-title
                class="headline"
                style="
                  justify-content: center;
                  font-size: 1em !important;
                  margin-top: -65px;
                "
              >
                <p>State specific company selected:</p>
                <p v-for="(value, index) in companyStates" :key="index">
                  <span v-if="index != Object.keys(companyStates).length - 1"
                    >,</span
                  >
                </p>
              </v-card-title>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="closeStateSpecificDialog(true)"
                >Ok</v-btn
              >
              <v-btn color="grey" @click="closeStateSpecificDialog(false)"
                >Cancel</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="confirm_submit" persistent max-width="400">
          <v-card>
            <div v-if="confirm_submit_text.length">
              <v-card-title class="headline">
                Please fill required fields!
              </v-card-title>
              <v-card-text>
                <ul>
                  <li
                    v-for="(a, i) in confirm_submit_text"
                    v-bind:key="i"
                    id="required"
                  >
                    {{ a }}
                  </li>
                </ul>
              </v-card-text>
            </div>
            <div v-if="confirm_submit_text_approved.length">
              <v-card-title class="headline">
                Please fill required for approval fields!
              </v-card-title>
              <v-card-text>
                <ul>
                  <li
                    v-for="(a, i) in confirm_submit_text_approved"
                    v-bind:key="i"
                    id="approved"
                  >
                    {{ a }}
                  </li>
                </ul>
              </v-card-text>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="confirm_submit = false"
                >OK</v-btn
              >
              <!-- <v-btn color="blue darken-1" text @click="send()">Continue</v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="after_submit" persistent max-width="400">
          <v-card>
            <v-card-title class="headline">
              {{ after_submit_msg.msg }}.
            </v-card-title>
            <v-card-text>
              Product Id: {{ after_submit_msg.product_id }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="productSuccessSubmit"
                >OK</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row>
        <v-col :cols="10"></v-col>
        <v-col :cols="2">
          <div style="text-align: right">
            <span
              ><span id="required">*</span
              ><strong> required field</strong></span
            ><br />
            <span
              ><span id="approved">*</span
              ><strong> required for approval</strong></span
            >
          </div>
          <!-- {{product_status}} -->
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="
          muid !== undefined &&
          media_channel == $c.media_chan.email &&
          $store.getters['ProductData/getMuid'] != ''
        "
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >MUID :
        </v-col>
        <v-col :cols="2" class="label-field text-left no-left no-bottom">
          <span>
            <a
              :href="`https://api3.competiscan.com/html-pdf/v2/html/${$store.getters['ProductData/getMuid']}`"
              target="_blank"
            >
              {{ $store.getters["ProductData/getMuid"] }}</a
            >
          </span>
        </v-col>
      </v-row>

      <v-row
        id="product__rowpadding"
        v-if="product_id !== undefined && product_id != ''"
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Product ID :
        </v-col>
        <v-col :cols="6" class="label-field text-left no-left no-bottom">
          {{ product_id }}</v-col
        >
      </v-row>

      <v-row id="product__rowpadding" v-if="last_worked_user !== ''">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Last Worked User:
        </v-col>
        <v-col
          :cols="6"
          class="label-field text-left no-left no-bottom"
          style="color: blue; cursor: pointer"
          @click="openlogmodal()"
          v-if="$route.name == 'addproduct' || $route.name == 'addproduct-v2'"
          >{{ last_worked_user }}</v-col
        >
        <v-col
          :cols="6"
          class="label-field text-left no-left no-bottom"
          style=""
          v-else
          >{{ last_worked_user }}</v-col
        >
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">{{
          email_subject
        }}</v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Panelists :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-btn small color="primary" @click="toggleAddPanelist"
            >Add Panelist</v-btn
          >
          <div class="tooltip" v-if="openPanelist">
            <ProductTooltip
              @closePanelist="closePanelist"
              @editDate="editFutureDate()"
            />
          </div>
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col
          :cols="4"
          class="label-field text-left no-right no-bottom"
        ></v-col>
        <v-col :cols="8" class="text-left no-left no-bottom no-top">
          <div class="flex">
            <div id="product__panelists">
              <ul id="product__panelists--list">
                <li
                  v-for="(p, i) in panelists"
                  v-bind:key="i"
                  v-ripple="{ class: `primary--text` }"
                >
                  <div id="product__panelists--list__left">
                    {{ panelistStrFormat(p) }}
                  </div>
                  <div id="product__panelists--list__right">
                    <v-btn
                      x-small
                      color="primary"
                      class="ma-1"
                      @click.prevent="editPanelist(i)"
                      >Edit</v-btn
                    >
                    <v-btn
                      x-small
                      color="primary"
                      @click.prevent="removePanelist(p)"
                      >Remove</v-btn
                    >
                  </div>
                </li>
              </ul>
            </div>
            <div v-if="showeditpanelist === true" class="tooltip">
              <EditPanelist
                @editDate="editFutureDate()"
                :index="editpan_index"
                @closeEditPanelist="showeditpanelist = false"
              />
            </div>
          </div>
          <!-- <v-checkbox label="State specific" v-model="state_specific" /> -->
          <!-- <span style="color:rgba(0, 0, 0, 0.6);">State specific</span> -->
        </v-col>
      </v-row>
      <!-- ------------------------------------move and delete started----------------- -->
      <div>
        <template>
          <div>
            <!-- Main Dialog for 'Move panelist | Move & delete' -->
            <v-dialog
              v-model="dialog"
              persistent
              max-width="450px"
              height="200px"
            >
              <template v-slot:activator="{ on, attrs }" height="200px">
                <!-- button move and delete start here -->

                <v-row id="product__rowpadding">
                  <v-col
                    :cols="4"
                    class="label-field text-left no-right no-bottom"
                    >&nbsp;</v-col
                  >
                  <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <!-- First Button for 'Move and Delete panelist' -->
                    <v-btn
                      small
                      :disabled="product_status == 1 || panelistIsPresent"
                      class="primary me-auto"
                      style="margin: 20px 0 20px 0"
                      v-bind="attrs"
                      @click="moveAndDelete()"
                    >
                      Move & delete
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- button end here  -->
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h7">{{ movePanelistHeader }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container class="pa-1">
                    <!-- Entry ID Field and Next/Cancel Buttons -->
                    <v-row class="align-center no-gutters">
                      <v-col cols="6">
                        <v-text-field
                          label="Entry ID:"
                          required
                          v-model="entryId"
                          dense
                          >{{ entryId }}</v-text-field
                        >
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          small
                          class="primary ml-3"
                          @click="handleNextButton"
                        >
                          Next
                        </v-btn>
                      </v-col>
                      <v-col cols="2">
                        <v-btn
                          small
                          class="primary small-button ml-3"
                          @click="handleCancelButton"
                        >
                          Cancel
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row class="text-center no-gutters">
                      <v-col>
                        <strong>OR</strong>
                      </v-col>
                    </v-row>

                    <!-- Product ID Field and Search Button -->
                    <v-row class="align-center no-gutters">
                      <v-col cols="6">
                        <v-text-field
                          label="Product ID:"
                          required
                          v-model="productId"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-btn
                          small
                          class="primary ml-3"
                          @click="searchEntryId"
                        >
                          Search
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>

            <!-- Secondary Dialog -->
            <v-dialog v-model="secondDialog" persistent max-width="450px">
              <v-card>
                <v-card-title>
                  <span class="text-h6">{{ movePanelistHeader }}</span>
                </v-card-title>
                <v-card-text>
                  <p>
                    Entry ID: <strong>{{ entryId }} </strong>
                  </p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="primary" @click="confirmMove">
                    MOVE & DELETE</v-btn
                  >
                  <v-btn class="primary" @click="handleCancelButton">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
      </div>
      <!-- ------------------------------------move and delete ended----------------- -->

      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >&nbsp;</v-col
        >
        <v-col :cols="2" class="text-left no-left no-bottom no-top">
          <v-checkbox
            label="State specific"
            v-model="state_specific"
            class="my-0 py-0 d-inline-block"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          <span>Entry Date <span id="required">*</span>:</span>
        </v-col>

        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <DatePicker
            :date="entry_date"
            @choose="entryDate"
            :disable_future="true"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="entry_id !== ''">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          <span>Entry ID : </span>
        </v-col>

        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-text-field v-model="entry_id" :readonly="true" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Offer Expiry Date :
        </v-col>
        <v-col :cols="5" class="text-left no-left no-bottom no-top">
          <DatePicker :date="offer_expiry_date" @choose="offerExpiryDate" />
        </v-col>
        <v-col :cols="1" class="text-left no-right no-bottom no-top">
          <v-btn color="primary" elevation="5" x-small @click="clearOfferDate"
            >Clear</v-btn
          >
        </v-col>
      </v-row>
      <!-- <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">Variant of Entry ID : </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <DatePicker :date="varient_entry_id" @choose="set_variant_entry_id" :disable_future="true"/>
                </v-col>
            </v-row>
            <v-row id="product__rowpadding" v-if="varient_entry_id.length">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">Variant Type : </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select :items="all_varient_type" v-model="varient_type" label="Variant Type" outlined  dense attach chips multiple/>
                </v-col>
            </v-row> -->
      <!-- Product PDF -->

      <v-row
        id="product__rowpadding"
        align="center"
        v-if="$route.query.ec_content_type == 'mobiledigital'"
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Product Media:
        </v-col>

        <v-col :cols="4" class="text-left no-left no-bottom no-top">
          <div
            v-if="
              mobile_digital_media !== null && mobile_digital_media.length != 0
            "
          >
            <div
              v-if="
                image_type_supported.includes(
                  mobile_digital_media[0].file_type.toLowerCase()
                ) == true
              "
              style="border:3px solid padding:5px"
            >
              <div
                style="
                  max-height: 100px;
                  max-width: 350px;
                  margin: 3px 0px 3px 0px;
                  overflow: scroll;
                  border: 1px solid;
                "
              >
                <img :src="mobile_digital_media[0].downlaod_url" />
              </div>
              <span
                @click="mobile_digital_image_preview(product_id, product_status)"
                style="color: blue; cursor: pointer"
                >View Image in full screen</span
              >
            </div>
            <div
              v-if="
                mobile_digital_media[0].file_type == 'MPEG-4' ||
                mobile_digital_media[0].file_type == 'mpeg-4' ||
                mobile_digital_media[0].file_type == 'mp4' ||
                mobile_digital_media[0].file_type == 'video'
              "
            >
              <video
                width="300"
                height="200"
                align="left"
                controls
                :src="mobile_digital_media[0].downlaod_url"
              ></video>
            </div>

            <div
              v-if="mobile_digital_media[0].file_type.toLowerCase() == 'html'"
            >
              <div
                style="
                  max-height: 100px;
                  max-width: 500px;
                  margin: 3px 0px 3px 0px;
                  overflow: scroll;
                  border: 1px solid;
                "
              >
                <iframe
                  frameBorder="0"
                  scrolling="no"
                  :src="mobile_digital_media[0].downlaod_url"
                  width="300"
                  height="250"
                ></iframe>
              </div>

              <div>
                <span
                  @click="
                    open_mobile_digital_product(
                      mobile_digital_media[0].downlaod_url
                    )
                  "
                  style="color: blue; cursor: pointer"
                  >View Image in full screen</span
                >
              </div>
            </div>
            <div v-if="mobile_digital_media[0].file_type.toLowerCase() == 'pdf'">
              <div 
                style="
                  max-height: 100px;
                  max-width: 350px;
                  margin: 3px 0px;
                  overflow: hidden;
                  border: 1px solid;
                "
              >
                <iframe
                  frameborder="0"
                  scrolling="no"
                  :src="mobileDigialPdfLink"
                  style="width: 100%; height: 100%; overflow: hidden;"
                ></iframe>
              </div>
              <div>
                <span
                  @click="open_mobile_digital_product(mobileDigialPdfLink)"
                  style="color: blue; cursor: pointer"
                >
                  View PDF in full screen
                </span>
              </div>
            </div>            
          </div>

          <v-btn small color="primary" @click="showEdit=!showEdit">
            {{showEdit?'Cancel':'Edit'}}
          </v-btn>
          <div v-if="showEdit">
          <v-file-input
              v-model="product_pdf"
              :accept="acceptedTypes"
              label="File input"
            ></v-file-input>
            <v-btn small color="primary" @click="upload_product_pdf()">
              Upload
            </v-btn>
            <v-progress-linear
              v-if="disable_all_buttons == true"
              height="30"
              striped
              style="width: 100%; color: #fff"
              class="mt-2"
            >
              <strong>
                {{ downloadPer + " " }}% ({{ `${transfer_rate} Mb/s` }})</strong
              >
            </v-progress-linear>
              <span v-if="file_upload_msg != ''" style="color: green">
                {{ file_upload_msg }}
              </span>
          </div>
          
          <span
            style="color: #1976d2; cursor: pointer"
            @click="showpdfcontent_textarea"
          >
            <strong>Manage Product Content</strong>
          </span>
        </v-col>
      </v-row>

      <v-row
        id="product__rowpadding"
        align="center"
        v-if="
          isAddProduct == true &&
          show_pdf_product_row == true &&
          $route.query.ec_content_type != 'uxmedia'
        "
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
          <span v-if="$route.query.ec_content_type == 'mobiledigital'"
            >Product Media <span id="approved">*</span>:</span
          >
          <span
            v-else-if="
              $route.query.channel_id == 19 || $route.query.channel_id == 20
            "
            >Product Media <span id="required">*</span>:</span
          >
          <span v-else>Product PDF <span id="required">*</span>:</span>
        </v-col>

        <v-col :cols="4" class="text-left no-left no-bottom no-top">
          <!-- changes done as per JIRAID 2293 (bug)-->
          <!-- removed function call that reset the pdf_content -->
          <v-file-input
            v-if="media_channel == 5"
            v-model="product_pdf"
            accept="image/png,image/jpeg,image.jpg,image/gif"
            label="File input"
          ></v-file-input>
          <v-file-input
            v-else-if="media_channel == 19 || media_channel == 20"
            v-model="product_pdf"
            :accept="acceptedTypes"
            label="Media File input"
            :rules="fileRules"
            :error-messages="fileErrorMessages"
            @change="validateFile"
            show-size
            counter
          ></v-file-input>
          <v-file-input
            v-else
            v-model="product_pdf"
            accept="application/pdf,application/vnd.ms-excel"
            label="File input"
          ></v-file-input>
          <v-btn small color="primary" @click="upload_product_pdf()">
            Upload
          </v-btn>
          <v-progress-linear
            v-if="disable_all_buttons == true"
            height="30"
            striped
            style="width: 100%; color: #fff"
            class="mt-2"
          >
            <strong>
              {{ downloadPer + " " }}% ({{ `${transfer_rate} Mb/s` }})</strong
            >
          </v-progress-linear>
          <span v-if="file_upload_msg != ''" style="color: green">
            {{ file_upload_msg }}
          </span>

          <div v-if="current_pdf_filename !== ''">
            <div
              v-if="$route.query.ec_content_type == 'mobiledigital'"
              style="
                max-height: 100px;
                max-width: 350px;
                margin: 3px 0px 3px 0px;
                overflow: scroll;
                border: 1px solid;
              "
            >
              <!--MOBILE DIGITAL --BLOCK-->
              <span
                v-if="
                  $store.getters['ProductData/getFileName'].split('.')[
                    $store.getters['ProductData/getFileName'].split('.')
                      .length - 1
                  ] != 'pdf'
                "
              >
                <img
                  :src="mobile_digital_file_url"
                  id="product__imagefile"
                  v-if="
                    mobile_digital_file_url !== null && mobile_digital_file_url
                  "
                />
              </span>
            </div>

            <span v-else>
              Current PDF :

              <a
                target="_blank"
                v-if="$route.query.ec_content_type == 'direct'"
                :href="$store.getters['ProductData/getPDFCDNLINK']"
                style="text-decoration: none"
                >{{ current_pdf_filename }}
              </a>
              <a
                target="_blank"
                v-else
                @click="open_product_pdf(current_pdf_product_id)"
                style="text-decoration: none"
                >{{ current_pdf_filename }}
              </a>
              [ <strong>Size:{{ document_size_byte }}</strong> ]

              <br />
              <!-- print media added as per JIRA ID-2885 -->
              <span
                v-if="
                  (media_channel == 1 || media_channel == 2) &&
                  original_document_size != 0 &&
                  original_document_size != '0B'
                "
              >
                <a
                  target="_blank"
                  style="text-decoration: None"
                  :href="$store.getters['ProductData/getPDFCDNLINKORIG']"
                  >Original PDF</a
                >
                <strong> [size:{{ original_document_size }}] </strong>
              </span>
              <br />
              <a
                @click="manage_pdf(current_pdf_product_id)"
                style="text-decoration: none"
                >Manage Preview</a
              >
            </span>
            <span
              v-if="$route.query.ec_content_type == 'mobiledigital'"
              @click="mobile_digital_preview(product_id)"
              style="color: blue; cursor: pointer"
              >View Image in full screen</span
            >
            <br />
          </div>

          
          <div>
            <br />
            <span
              style="color: #1976d2; cursor: pointer"
              @click="showpdfcontent_textarea"
            >
              <strong>Manage Product Content</strong>
            </span>
          </div>
        </v-col>
        <v-col :cols="4" class="text-left no-left no-bottom no-top">
          <v-checkbox
            v-if="content_type != '' && content_type == 'email'"
            :disabled="tmp_pdf_click == false"
            class="shrink mr-0 mt-1 my-0 py-0 d-inline-block"
            v-model="use_same_process_pdf"
            label="Use Process PDF"
            hide-details
          ></v-checkbox>
          <a
            style=""
            v-on:click="open_process_pdf()"
            v-if="content_type != '' && content_type == 'email'"
            ><strong>View Processed PDF</strong></a
          >
        </v-col>
      </v-row>

      <v-row
        id="product__rowpadding"
        align="center"
        v-if="$route.query.ec_content_type == 'uxmedia'"
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Product Media:
        </v-col>

        <v-col :cols="4" class="text-left no-left no-bottom no-top">
          <div v-if="uxmediaData !== null">
            <div
              v-if="
                uxmediaData.file_type == 'jpeg' ||
                uxmediaData.file_type == 'jpg' ||
                uxmediaData.file_type == 'png'
              "
              style="border:3px solid padding:5px"
            >
              <div
                style="
                  max-height: 400px;
                  max-width: 450px;
                  margin: 3px 0px 3px 0px;
                  overflow: scroll;
                  border: 1px solid;
                "
              >
                <img :src="uxmediaData.file_path" />
              </div>
              <span
                @click="mobile_digital_preview(uxmediaData.file_path)"
                style="color: blue; cursor: pointer"
                >View Image in full screen</span
              >
            </div>
            <div
              v-if="
                uxmediaData.file_type == 'MPEG-4' ||
                uxmediaData.file_type == 'mpeg-4' ||
                uxmediaData.file_type == 'mp4' ||
                uxmediaData.file_type == 'mkv' ||
                uxmediaData.file_type == 'avi' ||
                uxmediaData.file_type == 'mov' ||
                uxmediaData.file_type == 'video'
              "
            >
              <video
                width="300"
                height="200"
                align="left"
                controls
                :src="uxmediaData.file_path"
              ></video>
            </div>

          <div v-if="uxmediaData.file_type == 'pdf'">
            <div 
              style="
                max-height: 100px;
                max-width: 350px;
                margin: 3px 0px;
                overflow: hidden;
                border: 1px solid;
              "
            >
              <iframe
                frameborder="0"
                scrolling="no"
                :src="uxmediaData.pdf_cdn_link"
                style="width: 100%; height: 100%; overflow: hidden;"
              ></iframe>
            </div>
            <div>
              <span
                @click="open_mobile_digital_product(uxmediaData.pdf_cdn_link)"
                style="color: blue; cursor: pointer"
              >
                View PDF in full screen
              </span>
            </div>
          </div>
            
          </div>
          <v-btn small color="primary" @click="showEdit=!showEdit">
              {{showEdit?'Cancel':'Edit'}}
            </v-btn>

          <div v-if="showEdit">
            <v-file-input
              v-model="product_pdf"
              :accept="acceptedTypes"
              label="File input"
            ></v-file-input>
            <v-btn small color="primary" @click="upload_product_pdf()">
              Upload
            </v-btn>
            <v-progress-linear
              v-if="disable_all_buttons == true"
              height="30"
              striped
              style="width: 100%; color: #fff"
              class="mt-2"
            >
              <strong>
                {{ downloadPer + " " }}% ({{ `${transfer_rate} Mb/s` }})</strong
              >
              <span v-if="file_upload_msg != ''" style="color: green">
                {{ file_upload_msg }}
              </span>
            </v-progress-linear>
          </div>
          <div
            style="color: #1976d2; cursor: pointer"
            @click="showpdfcontent_textarea"
          >
            <strong>Manage Product Content</strong>
          </div>
        </v-col>
        
      </v-row>

      <!-- End here-->
      <v-row id="product__rowpadding" align="center" v-if="showpdfcontent">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Manage Pdf Content :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-textarea
            outlined
            v-model="pdf_content"
            name="input-7-4"
            label="Manage PDF Content"
            value=""
          ></v-textarea>
          <v-dialog v-model="pdftextdialog" scrollable width="600px">
            <template v-slot:activator="{ on }">
              <span v-on="on" v-if="content_limit_exceeded == true">
                Pdf content character length exceed the limit: 50000 . please
                click to
                <strong style="color: #1976d2; cursor: pointer"
                  >View Content</strong
                ></span
              >
            </template>
            <v-card height="500px">
              <v-card-title>
                <span class="text-h5">PDF Text</span>
              </v-card-title>
              <v-card-text>
                {{ display_content_text }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="green darken-1"
                  text
                  @click="pdftextdialog = false"
                >
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>

      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Company <span id="approved">*</span>:</v-col
        >
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-btn small color="primary" @click.prevent="openAddCompany = true"
            >Add Company</v-btn
          >
          <AddCompanyTooltip
            @selectCompany="selectCompany"
            @close="closeAddCompany"
            v-if="openAddCompany === true"
          />
          <div id="product__addcompany" v-if="companies.length > 0">
            <ul id="product__addcompany--list">
              <li v-for="(c, i) in companies" v-bind:key="i">
                {{ c.companyName }}
                <p>
                  <a v-if="isDisplayedImage(c)" @click.prevent="showImage(c)">
                    ( Product Image )
                  </a>
                  <span
                    v-ripple="{ class: `primary--text` }"
                    @click.prevent="traverseCompanies(c, true)"
                    >Up</span
                  >
                  <span
                    v-ripple="{ class: `primary--text` }"
                    @click.prevent="traverseCompanies(c, false)"
                    >Down</span
                  >
                  <span
                    v-ripple="{ class: `primary--text` }"
                    @click.prevent="removeCompany(c)"
                    >Remove</span
                  >
                </p>
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>

      <!-- <v-row id="product__rowpadding" v-if="content_type != 'direct'">
        <v-col
          :cols="4"
          class="label-field text-left no-right no-bottom"
        ></v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <a @click.prevent="manageCompany()">Manage Company</a>
        </v-col>
      </v-row> -->

      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Product Image <span id="approved">*</span>:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-file-input accept="image/*" label="File input"></v-file-input>

          <img
            :src="img_url"
            id="product__imagefile"
            v-if="img_url !== null && img_url"
          />
          <div id="product__imagefile" v-else>
            <h4>Image Not Available</h4>
          </div>
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="content_type != 'direct' && muid !== undefined"
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Html/PDF :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <font-awesome-icon
            icon="file-code"
            id="product__iconhtml"
            @click.prevent="showHtml()"
          />
          <font-awesome-icon
            icon="file-pdf"
            id="product__iconpdf"
            @click.prevent="showPdf()"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Affinity/Association :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-btn
            small
            color="primary"
            @click.prevent="openAffinityAssociation = true"
          >
            Add Affinity/Association
          </v-btn>
          <AffinityAssociationTooltip
            @closeAffinityAssociation="closeAffinityAssociation"
            @chooseAffinity="chooseAffinity"
            v-if="openAffinityAssociation === true"
          />
          <ul id="affinity_association">
            <li v-for="(a, i) in affinity" v-bind:key="i" style="padding: 5px">
              {{
                a.affinityName +
                (a.AffinityCategoryName === null
                  ? ""
                  : " (" + a.AffinityCategoryName + ") ")
              }}
              <v-btn
                x-small
                color="primary"
                class="ma-0"
                @click.prevent="removeAffinity(a.affinityID)"
                >Remove</v-btn
              >
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Media Channel <span id="required">*</span>:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            v-if="$route.query.channel_id !== undefined"
            :items="all_media_chan"
            dense
            outlined
            v-model="media_channel"
          />

          <v-select
            v-else
            :items="all_media_chan"
            dense
            outlined
            v-model="media_channel"
          />
        </v-col>
      </v-row>
      <MediaChannal />
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Audience <span id="required">*</span>:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select outlined :items="all_audience" dense v-model="audience" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Sector<span id="approved"> * </span>/Category<span id="approved">
            *
          </span>
          /Sub Category :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <div id="product__addcompany" v-if="sectorsData.length > 0">
            <ul id="product__addcompany--list">
              <li v-for="(c, i) in sectorsData" v-bind:key="i">
                <span v-for="(el, index) in c" v-bind:key="index">
                  <strong v-if="index == 0">{{ el.name }}</strong>
                  <strong v-else>/ {{ el.name }}</strong>
                </span>
                <span
                  v-ripple="{ class: `primary--text` }"
                  @click.prevent="traverseSectorCombinations(i, true)"
                  >Up</span
                >
                <span
                  v-ripple="{ class: `primary--text` }"
                  @click.prevent="traverseSectorCombinations(i, false)"
                  >Down</span
                >
                <span
                  v-ripple="{ class: `primary--text` }"
                  @click.prevent="editSectorCombination(i)"
                  >Edit</span
                >
                <span
                  v-ripple="{ class: `primary--text` }"
                  @click.prevent="removeSectorCombination(i)"
                  >Remove</span
                >
              </li>
            </ul>
          </div>
          <div id="product__categories">
            <v-select
              :items="all_sectors"
              outlined
              dense
              :label="SectorLabel"
              v-model="watchsectors"
            />
            <v-select
              :items="all_category"
              outlined
              dense
              :label="CategoryLabel"
              v-model="watchcategory"
            />
            <v-select
              :items="all_sub_category"
              outlined
              dense
              :label="SubCategoryLabel"
              v-model="watchsubcategory"
            />
            <v-select
              :items="all_sub_sub_category"
              outlined
              dense
              :label="SubSubCategoryLabel"
              v-model="watchsubsubcategory"
            />
            <v-btn
              x-small
              color="primary"
              class="ma-1"
              @click.prevent="addSectorCombination('add', sectorsData.length)"
              v-if="!editSectorMode"
              >Add</v-btn
            >
            <v-btn
              x-small
              color="primary"
              class="ma-1"
              @click.prevent="
                updateSectorCombination(editSectorCombinationIndex)
              "
              v-if="editSectorMode"
              >Update</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.issue_type">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Issue Type :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_issue_types"
            v-model="issueType"
            outlined
            dense
            attach
            chips
            multiple
          />
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="toggle_sector_divs.offer_origin == true"
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Offer Origin <span id="approved">*</span>:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            v-model="offer_origin"
            :items="all_offer_origin"
            outlined
            dense
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Product Name <span id="approved">*</span>:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <div v-if="toggle_sector_divs.product_lookup">
            <v-row>
              <v-col :cols="12" class="text-left no-left no-bottom no-top">
                <v-text-field
                  v-model="searchProductNames"
                  ref="product_name_search"
                  placeholder="Lookup"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                :cols="12"
                class="text-left no-left no-bottom no-top pa-0 ma-0"
              >
                <div id="productlookuptooltip__tooltip">
                  <ul id="productlookuptooltip__tooltip--list">
                    <li
                      v-for="(a, i) in product_names"
                      v-bind:key="i"
                      v-ripple="{ class: `primary--text` }"
                      @click.prevent="chooseProductName(a)"
                    >
                      {{ a }}
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-text-field
            :readonly="toggle_sector_divs.product_lookup"
            outlined
            dense
            v-model="product_name"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" no-gutters>
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Product Headline <span id="approved">*</span>:
        </v-col>
        <v-col :cols="6" class="m-0 pl-2 text-left">
          <!-- <v-textarea
            name="input-7-1"
            v-if="isDigitalMediaChannel()"
            outlined
            dense
            @click="populateHeadline()"
            v-model="product_headline"
          /> -->
          <textarea
            id="hedlinetextarea"
            rows="5"
            cols="75"
            style="
              font-size: 12px;
              line-height: 20px;
              padding: 10px;
              font-family: inherit;
              border: 1px #7e7b7b solid;
              resize: both !important;
              border-radius: 4px;
              width: 100%;
              max-width: 135%;
            "
            v-model="product_headline"
            @blur="duplicate_headline(product_headline)"
          >
          </textarea>

          <!-- <v-textarea name="input-7-1" autocomplete="product_headline" outlined dense v-model="product_headline"  onblur="duplicate_headline(product_headline)" /> -->
          <div
            id="headline_alert"
            class="headlinealert"
            v-show="duplicate_headline_status"
          >
            <span
              class="closebtn"
              onclick="this.parentElement.style.display='none';"
              >&times;</span
            >
            {{ duplicate_headline_text }}
          </div>
        </v-col>
        <v-col cols="1" class="ml-1" v-if="headline_loader">
          <v-progress-circular
            :size="25"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="media_channel === 5">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Observed Traffic Source :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-textarea
            outlined
            dense
            name="input-7-1"
            v-model="observed_traffic_source"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Worksite/Voluntary :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-checkbox
            v-model="worksite_voluntary"
            class="my-0 py-0 d-inline-block"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.perscription">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Rx :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-checkbox v-model="perscription" class="my-0 py-0 d-inline-block" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.is_hphsa">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >CDHP/HDHP/HSA :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-checkbox v-model="is_hphsa" class="my-0 py-0 d-inline-block" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Pre-Screen & Opt-Out Notice :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-checkbox v-model="isPreScreen" class="my-0 py-0 d-inline-block" />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.fee_product">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Fee Product :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-checkbox v-model="fee_product" class="my-0 py-0 d-inline-block" />
        </v-col>
      </v-row>

      <v-row id="product__rowpadding" v-if="toggle_sector_divs.tip_on_card">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Tip on Card :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-checkbox v-model="tip_on_card" class="d-inline-block" />
        </v-col>
      </v-row>

      <v-row id="product__rowpadding" v-if="toggle_sector_divs.handwriting">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Handwriting :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-checkbox v-model="handwriting" class="d-inline-block" />
        </v-col>
      </v-row>

      <v-row id="product__rowpadding" v-if="toggle_sector_divs.faux_check">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Faux Check :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-checkbox v-model="faux_check" class="my-0 py-0 d-inline-block" />
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="toggle_sector_divs.ancilarry_products"
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Ancillary Products :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_ancilary_products"
            v-model="ancillaryProducts"
            outlined
            dense
            attach
            chips
            multiple
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.group_size">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Group Size :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_group_size"
            v-model="groupSize"
            outlined
            dense
            attach
            chips
            multiple
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.face_amount">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Face Amount :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_face_amount"
            v-model="faceAmount"
            outlined
            dense
            attach
            chips
            multiple
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.term_length">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Term Length :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_term_length"
            v-model="termLength"
            outlined
            dense
            attach
            chips
            multiple
          />
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="media_channel === 1 || media_channel === 2"
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >DM/TM Source <span id="required">*</span>:
        </v-col>
     <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-row>
            <v-col flex>
            <v-text-field class="mb-0" outlined dense v-model="dm_tm_source" />
            
            </v-col>
            <v-col  cols="auto" class="d-flex flex-column align-center px-0">
              <img
                v-if="dm_tm_source === '' && $route.query.ec_content_type === 'print_media'"
                :src="aiImage"
                alt="img_suggestion"
                style="cursor: pointer"
                class="mb-2"
                @click="fetchDmSourceFilename"
              />
            </v-col>
          </v-row>
        </v-col>

      </v-row>


      <v-row id="product__rowpadding" v-if="media_channel === 2">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Publication <span id="approved">*</span>:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-btn small color="primary" @click.prevent="addpublication = true"
            >Add Publication</v-btn
          >
          <div class="tooltip" v-if="addpublication">
            <AddPublicationTooltip @close="addpublication = false" />
          </div>
          <ul id="affinity_association">
            <li v-for="(p, i) in publications" v-bind:key="i">
              {{ p.publication_name }} [{{ p.publication_date }}]
              <span
                @click.prevent="removePublication(p)"
                id="affinity_association--btn"
                >Remove</span
              >
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="sectorsData.length > 0">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Response Mechanism :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_response_type"
            v-model="response_mechanism"
            outlined
            dense
            attach
            chips
            multiple
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Business Content :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_business_content"
            outlined
            dense
            v-model="business_content"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Personalization <span id="approved">*</span>:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-radio-group :mandatory="false" row v-model="personalization">
            <v-radio label="Personalized" :value="1"></v-radio>
            <v-radio label="Non Personalized" :value="2"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Mailing Type <span id="approved"> * </span>:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_mailing_type"
            outlined
            dense
            v-model="mailing_type"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-if="toggle_sector_divs.riders">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Riders :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_riders"
            v-model="riders"
            outlined
            dense
            attach
            chips
            multiple
          />
        </v-col>
      </v-row>

      <Delivery v-bind:showDelivery="toggle_sector_divs.delivery" />
      <v-row id="product__rowpadding" v-if="sectorsData.length > 0">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Communication Type:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_comm_type"
            v-model="communication_type"
            outlined
            dense
            attach
            chips
            multiple
          />
        </v-col>
      </v-row>
      <Incentive1
        :counter="counter"
        :incentive_rules="incentive_rules"
        v-if="isBonusContentIncentive()"
      />
      <Incentive2
        :counter="counter"
        :incentive_rules="incentive_rules"
        v-if="isBonusContentIncentive()"
      />
      <Incentive3
        :counter="counter"
        :incentive_rules="incentive_rules"
        v-if="isBonusContentIncentive()"
      />
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Campaign Language :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_campaign_language"
            outlined
            dense
            v-model="campaign_language"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Target Market :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="all_targetmarket"
            attach
            chips
            multiple
            v-model="target_market"
            outlined
            dense
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >State Province<span id="approved"> * </span>:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-select
            :items="states"
            attach
            chips
            multiple
            v-model="state_province"
            outlined
            dense
          />
        </v-col>
      </v-row>
      <v-row
        id="product__rowpadding"
        v-if="
          media_channel === 5 ||
          media_channel === 2 ||
          media_channel === 6 ||
          media_channel === 10 ||
          media_channel === 1
        "
      >
        <v-col
          :cols="4"
          class="label-field text-left no-right no-bottom"
          v-if="media_channel != 1"
          >Primary Country :
        </v-col>
        <v-col
          :cols="6"
          class="text-left no-left no-bottom no-top"
          v-if="media_channel != 1"
        >
          <v-select
            :items="all_primary_country"
            attach
            outlined
            dense
            v-model="primary_country"
          />
        </v-col>
      </v-row>
      <v-row id="product__rowpadding">
        <v-col
          :cols="4"
          class="label-field text-left no-right no-bottom"
        ></v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <a @click="toggleDemoGraphicInfo"
            ><strong>Manage Demographics Information</strong></a
          >
        </v-col>
      </v-row>
      <div v-if="toggle_sector_divs.demographic_info">
        <v-row id="product__rowpadding">
          <v-col :cols="4" class="label-field text-left no-right no-bottom"
            >Gender :
          </v-col>
          <v-col :cols="6" class="text-left no-left no-bottom no-top">
            <v-radio-group :mandatory="false" row v-model="gender">
              <v-radio label="Male" value="M"></v-radio>
              <v-radio label="Female" value="F"></v-radio>
              <v-radio label="Both" value="B"></v-radio>
              <v-radio label="None" value="N"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row id="product__rowpadding">
          <v-col :cols="4" class="label-field text-left no-right no-bottom"
            >Age</v-col
          >
          <v-col :cols="6" class="text-left no-left no-bottom no-top">
            <v-select
              :items="all_age_product"
              v-model="product_age"
              outlined
              dense
              attach
              chips
              multiple
            />
          </v-col>
        </v-row>
        <v-row id="product__rowpadding">
          <v-col :cols="4" class="label-field text-left no-right no-bottom"
            >Income</v-col
          >
          <v-col :cols="6" class="text-left no-left no-bottom no-top">
            <v-select
              :items="all_income_type"
              attach
              chips
              multiple
              v-model="product_income"
              outlined
              dense
            ></v-select>
          </v-col>
        </v-row>
      </div>
      <Banking v-bind:showBanking="toggle_sector_divs.banking" />
      <CreditCard v-bind:showCreditCard="toggle_sector_divs.creditCard" />
      <MortgageLoans
        v-bind:showMortgageLoans="toggle_sector_divs.MortgageLoans"
      />
      <Telecom v-bind:showTelecom="toggle_sector_divs.telecom" />
      <TravelLeisure
        v-bind:showTravelLeisure="toggle_sector_divs.travelLeisure"
      />
      <PaymentCard v-bind:showPaymentCard="toggle_sector_divs.paymentCard" />
      <Energy v-bind:showEnergy="toggle_sector_divs.energy" />
      <Retail
        v-bind:showRetail="toggle_sector_divs.retail"
        v-bind:showNonProfit="toggle_sector_divs.non_profit"
        v-bind:showConsumerService="toggle_sector_divs.consumer_service"
      />
      <Advertiser
        v-bind:advertiserSectorsSet="toggle_sector_divs.advertiserSectorsSet"
      />
      <Promotion
        ref="promotion"
        v-bind:promotionSectorsSet="toggle_sector_divs.promotionSectorsSet"
      />
      <!-- <v-row id="product__rowpadding">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >CITI :
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-radio-group :mandatory="false" row v-model="citi">
            <v-radio label="Yes" :value="1"></v-radio>
            <v-radio label="No" :value="0"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row> -->
      <v-row id="product__rowpadding" v-if="isAddProduct == true">
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Comment:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-textarea
            name="input-7-1"
            outlined
            dense
            v-model="product_comment"
          />
        </v-col>
      </v-row>

      <v-row id="product__rowpadding" v-if="isAddProduct == true">
        <v-col :cols="4" class="label-field text-left no-right no-bottom">
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <v-btn
            elevation="2"
            small
            outlined
            color="indigo"
            @click="opensendemailmodal"
            v-if="product_status == 1 && is_deleted != 1"
          >
            Link to your colleague
          </v-btn>
        </v-col>
      </v-row>

      <v-row
        id="product__rowpadding"
        v-if="isAddProduct == true && product_status != ''"
      >
        <v-col :cols="4" class="label-field text-left no-right no-bottom"
          >Product Status:
        </v-col>
        <v-col :cols="6" class="text-left no-left no-bottom no-top">
          <span v-if="product_status == 1"> Approved </span>
          <span v-if="product_status == 2"> UnApproved </span>
          <span v-if="product_status == 4"> Problem </span>
          <span v-if="product_status == 10"> Glacier </span>
          <span v-if="product_status == 11"> Temp Product </span>
          <span v-if="product_status == -1"> Unused</span>
          <span v-if="product_status == 5"> FTP</span>
          <span v-if="product_status == 3"> Reprocessed</span>
          <span v-if="product_status == 14"> In Progress</span>
        </v-col>
      </v-row>
      <!-- <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">On Home Page : </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-radio-group :mandatory="false" row>
                        <v-radio label="Yes"></v-radio>
                        <v-radio label="No"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">High Priority : </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-checkbox/>
                </v-col>
            </v-row> -->
      <v-row id="product__rowpadding" v-if="sectors_allowed">
        <v-col
          :cols="4"
          class="label-field text-left no-right no-bottom"
        ></v-col>
        <v-col
          :cols="6"
          class="text-left no-left no-bottom no-top"
          v-if="isAddProduct == false"
        >
          <span v-if="product_status == 0 || product_status == 11">
            <v-btn
              small
              color="primary"
              v-if="email_status == 'used'"
              id="product__submit"
              @click.prevent="submit"
              >Update</v-btn
            >
            <v-btn
              small
              color="primary"
              v-else
              id="product__submit"
              @click.prevent="submit"
            >
              {{ update_type === true ? "Update" : "Submit" }}
            </v-btn>
            <v-btn small color="error" @click.prevent="cancel">Cancel</v-btn>
          </span>
          <span v-else style="color: red">
            Temp product has already been created
          </span>
        </v-col>

        <v-col
          :cols="8"
          class="text-left no-left no-bottom no-top"
          v-if="isAddProduct == true && is_deleted != 1"
        >
          <v-btn
            small
            :disabled="disable_all_buttons"
            color="primary"
            id="product__submit"
            @click.prevent="approved"
            >Approved</v-btn
          >
          <v-btn
            small
            :disabled="disable_all_buttons"
            color="warning"
            id="product__submit"
            @click.prevent="unapproved"
            >Unapproved</v-btn
          >
          <v-btn
            small
            :disabled="disable_all_buttons"
            color="success"
            id="product__submit"
            @click.prevent="problem"
            >Problem</v-btn
          >
          <v-btn
            small
            :disabled="disable_all_buttons"
            color="error"
            id="product__submit"
            @click.prevent="reprocessed"
            >Reprocessed</v-btn
          >
          <v-btn
            small
            :disabled="disable_all_buttons"
            color="error"
            @click="deleteProduct(product_id)"
            >Delete</v-btn
          >
        </v-col>
      </v-row>
      <v-row id="product__rowpadding" v-else>
        <v-col
          :cols="4"
          class="label-field text-left no-right no-bottom"
        ></v-col>
        <v-col :cols="8" class="text-left no-left no-bottom no-top">
          <p style="color: red">You do not have permission</p>
        </v-col>
      </v-row>

      <v-row v-if="is_deleted == 1" justify="center" align="center">
        <v-col :cols="10">
          <v-alert dense outlined type="error">
            Product has been move to archieve section.To restore this product
            Please contact to administrator
          </v-alert></v-col
        >
      </v-row>
      <!-- <v-row id="product__lastrow">
                 <v-col :cols="4" class="label-field text-left no-right no-bottom">Attachments : </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-file-input accept="image/*" counter multiple  dense show-size label="File input"></v-file-input>
                </v-col>
            </v-row> -->
    </v-container>
    <template>
      <v-dialog persistent v-model="sendemaildialog" max-width="500">
        <!-- Changes Link to JID-2023 -->

        <SendLink
          @sendEmail="sendEmail"
          :subject="subject"
          product_id="product_id"
          entry_id="entry_id"
          @cancelEmail="cancelEmail"
        />
      </v-dialog>

      <v-dialog v-model="productadmindialog" max-width="500">
        <v-card>
          <v-card-title
            align="center"
            class="headline"
            style="padding-left: 30%"
          >
            Product Activity Log
          </v-card-title>

          <v-data-table
            :headers="userheaders"
            hide-default-footer
            disable-pagination
            :items="logdata"
            class="elevation-1"
          >
            <template v-slot:item.logDate="{ item }">
              <span>{{ formateDate(item.logDate) }}</span>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click="productadmindialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row justify="center">
        <v-dialog v-model="pdftextdialog" width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">PDF Text</span>
            </v-card-title>
            <v-card-text>
              {{ pdf_content }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="pdftextdialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-app>
</template>

<script>
/*eslint-disable*/
import _ from "lodash";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import DatePicker from "./../utilities/DatePicker";
import ProductTooltip from "./../components/product/PanelistTooltip";
import EditPanelist from "./../components/product/EditPanelist";
import Incentive1 from "./../components/product/Incentive1";
import Incentive2 from "./../components/product/Incentive2";
import Incentive3 from "./../components/product/Incentive3";
import AddCompanyTooltip from "./../components/product/AddCompanyTooltip";
import AffinityAssociationTooltip from "./../components/product/AffinityAssociationTooltip";
import MediaChannal from "./../components/product/MediaChannal";
import Banking from "./../components/product/Banking";
import CreditCard from "./../components/product/CreditCard";
import MortgageLoans from "./../components/product/MortgageLoans";
import Retail from "./../components/product/Retail";
import Telecom from "./../components/product/Telecom";
import TravelLeisure from "./../components/product/TravelLeisure";
import PaymentCard from "./../components/product/PaymentCard";
import Energy from "./../components/product/Energy";
import Delivery from "./../components/product/Delivery";
import Advertiser from "./../components/product/Advertiser";
import Promotion from "./../components/product/Promotion";
//changes done for JIRAID-2023
import SendLink from "./../components/SendLink";
import AddPublicationTooltip from "./../components/product/AddPublicationTooltip";
// import EditPublication from './../components/product/EditPublication'
import { mapGetters } from "vuex";
import moment from "moment";
import { vueTopprogress } from "vue-top-progress";
import axios from "axios";
import { toInteger } from "lodash";
import aiImage from './../assets/img/ai-logo.png';
export default {
  name: "Product",
  data: () => ({
    showEdit:false,
    uxmediaData: "",
    futureDateSelected: false,
    dialog: false,
    aiImage: aiImage,
    secondDialog: false,
    panelistIsPresent: true,
    entryId: "",
    productId: "",
    moveAndDeletePanelist: "",
    // sourceEntryDate :"",
    movePanelistHeader: "Move & Delete Panelists",
    successMoved: "",
    content_limit_exceeded: false,
    counter: 500,
    headline_loader: false,
    duplicate_headline_status: false,
    duplicate_headline_text: "",
    sendemaildialog: false,
    subject: "Link to a product of your interest",
    message: "",
    pdf_cdn_link_orig: "",
    base_file_path: "https://files3.competiscan.com/",
    upload_button_click: false,
    file_upload_msg: "",
    downloadPer: 0,
    transfer_rate: 0,
    ProgressBar: false,
    disable_all_buttons: false,
    disable_product_publish_button: false,
    fixed_header: false,
    productadmindialog: false,
    logdata: [],
    uploadPercentage: 0,
    userheaders: [
      {
        text: "UserName",
        value: "userid",
        width: "40%",
        class: "",
      },
      {
        text: "Action",
        value: "ProductActivity",
        width: "40%",
        class: "",
      },
      {
        text: "Date",
        value: "logDate",
        width: "20%",
        class: "",
        sortable: false,
      },
    ],

    product_id: "",
    product_file_ext: "",
    show_pdf_product_row: false,
    is_mobile: 1,
    is_banner_product: false,
    sectors_allowed: true,
    mobile_digital_media: [],
    image_type_supported: [
      "application",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image",
      "PNG",
      "JPEG",
      "JPG",
      "GIF",
      "jpg",
      "jpeg",
      "png",
      "gif",
    ],
    new_entry_date: "",
    downlaod_url: "",
    pdftextdialog: false,
    showpdfcontent: false,
    confirm_submit: false,
    after_submit: false,
    content_type: "",
    after_submit_msg: "",
    confirm_submit_text: "",
    confirm_submit_text_approved: "",
    editpan_index: "",
    muid: "",
    product_names: [],
    email_subject: "",
    items: ["Foo", "Bar", "Fizz", "Buzz"],
    openPanelist: false,
    showeditpanelist: false,
    openAddCompany: false,
    openAffinityAssociation: false,
    panelistdata: {
      date: "",
      invitationId: "",
      last4digits: "",
      panelist: "",
    },
    watchsectors: "",
    watchcategory: "",
    watchsubcategory: "",
    watchsubsubcategory: "",
    watch_audience: "",
    editSectorMode: false,
    editSectorCombinationIndex: "",
    isLoading: false,
    fullPage: true,
    SectorLabel: "Sector",
    CategoryLabel: "Category",
    SubCategoryLabel: "Sub-Category",
    SubSubCategoryLabel: "Sub Sub Category",
    toggle_sector_divs: {
      paymentCard: false,
      banking: false,
      creditCard: false,
      MortgageLoans: false,
      retail: false,
      telecom: false,
      travelLeisure: false,
      energy: false,
      delivery: false,
      offer_origin: true,
      demographic_info: false,
      ancilarry_products: true,
      group_size: false,
      riders: false,
      face_amount: false,
      term_length: false,
      issue_type: false,
      perscription: false,
      is_hphsa: false,
      fee_product: false,
      faux_check: false,
      tip_on_card: false,
      handwriting: false,
      product_lookup: false,
      advertiserSectorsSet: false,
      promotionSectorsSet: false,
      non_profit: false,
      consumer_service: false,
    },
    addpublication: false,
    update_type: false,
    searchProductNames: null,
    isAddProduct: null,
    newproduct: null,
    //product pdf constants
    product_pdf: null,
    fileErrorMessages: [],
    fileRules: [
      (v) => !v || (v.type && this.isValidFileType(v)) || "Invalid file type",
    ],
    product_media: null,
    use_same_process_pdf: false,
    pdf_uploaded: false,
    pdf_filename: null,
    download_link: null,
    tmp_pdf_click: false,
    temppdf_url: null,
    current_pdf_path: "",
    current_pdf_product_id: "",
    current_pdf_filename: "",
    pdf_destination: "",
    img_destination: [],
    img_files: [],
    uploaded_pdf_filename: "",
    companies_state_species: false,
    companies_state_modal: false,
    companyStates: [],
    btnClick: "",
    dmSourceFilename: '', 
  }),
  components: {
    DatePicker,
    vueTopprogress,
    Loading,
    ProductTooltip,
    EditPanelist,
    Incentive1,
    Incentive2,
    Incentive3,
    AddCompanyTooltip,
    AffinityAssociationTooltip,
    MediaChannal,
    Banking,
    CreditCard,
    MortgageLoans,
    Retail,
    Telecom,
    TravelLeisure,
    PaymentCard,
    Energy,
    Delivery,
    Advertiser,
    Promotion,
    AddPublicationTooltip,
    //Changes Link to JID-2023
    SendLink,
    // EditPublication,
  },
  mounted() {
    this.checkPanelistDate(),
      // this code has been moved to watch
      this.$nextTick(() => {
        this.checkProgress();
        this.$watch(
          () => this.$refs.topProgress.progress,
          (newVal) => {
            this.updateButtonState(newVal);
          }
        );
      });
  },
  computed: {
    acceptedTypes() {
      // Accept images, video, and PDFs (no audio)
      return ".jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff,.pdf,.mp4,.avi,.mov,.wmv,.flv,.mkv,.webm";
    },
    panelistDate() {
      return this.$store.getters["ProductData/getPanelists"];
    },
    // panelistDateInLocal(){
    //   return this.$store.getters["ProductData/getEntryId"];

    // },
    ...mapGetters({
      //all_offer_origin: "ProductData/getAllOfferOrigin",
      //all_sectors: "ProductData/getAllSectors",
      all_income_type: "ProductData/getAllIncomeType",
      all_age_product: "ProductData/getAllAgeProduct",
      all_primary_country: "ProductData/getAllPrimaryCountry",
      //all_face_amount: "ProductData/getFaceAmount",
      //all_group_size: "ProductData/getAllGroupSize",
      //all_riders: "ProductData/getAllRiders",
      all_ancilary_products: "ProductData/getAllAncilaryProducts",
      all_issue: "ProductData/getAllIssues",
      all_audience: "ProductData/getAudience",
      all_media_chan: "ProductData/getMediaChannel",
      states: "ProductData/getProductStates",
      all_targetmarket: "ProductData/getAllTargetMarket",
      all_campaign_language: "ProductData/getAllCampaignLanguage",
      all_mailing_type: "ProductData/getAllMailingType",
      all_business_content: "ProductData/getAllBusinessContent",
      all_category: "ProductData/getAllCategory",
      all_sub_category: "ProductData/getAllSubCategory",
      all_sub_sub_category: "ProductData/getAllSubSubCategory",
      all_varient_type: "ProductData/getVarientAllType",
      //all_comm_type: 'ProductData/getAllCommType',
      //all_response_type: 'ProductData/getAllResponseType',
      affinity: "ProductData/getAffinity",
      companies: "ProductData/getCompanies",
      panelists: "ProductData/getPanelists",
      sectors: "ProductData/getSector",
      email_status: "Email/getStatus",
      publications: "ProductData/getPublications",
      sectorsData: "ProductData/getSector",
      //communication_types: "ProductData/getCommunicationType",
      img_url: "ProductData/getCurrentCompanyImage",
      last_worked_user: "ProductData/getLastWorkedUser",
      spacy_orgn_companies: "ProductData/getSecComPred",
      entry_date: "ProductData/getEntryDate",
      product_comment: "ProductData/getProductComment",
      product_status: "ProductData/getProductStatus",
      entry_id: "ProductData/getEntryId",
      current_pdf: "ProductData/getCurrentPdf",
      pdf_cdn_link: "ProductData/getPDFCDNLINK",
      banner_product_path: "ProductData/getBannerProductPath",
      pdf_content: "ProductData/getPdfContent",
      mobile_digital_file_type: "ProductData/getMobileDigtialFileType",
      mobile_digital_file_url: "ProductData/mobile_digital_file_url",
      mobile_digital_file_size: "ProductData/getMobileDigtialFileSize",
      document_size_byte: "ProductData/getDocumentSizeByte",
      original_document_size: "ProductData/getOriginalDocumentSize",
      is_mobile: "ProductData/getIsMobileProduct",
      ec_content_type: "ProductData/getEcContentType",
      is_deleted: "ProductData/getIsDeleted",
    }),
    incentive_rules() {
      return [
        (v) =>
          v.length <= this.counter ||
          `Maximum character limit : ${this.counter}`,
      ];
    },
    product_status: {
      get: function () {
        var view = this;
        return view.$store.getters["ProductData/getProductStatus"];
      },
    },
    ec_content_type: {
      get: function () {
        var view = this;
        return view.$store.getters["ProductData/getEcContentType"];
      },
    },

    all_sectors: {
      get: function () {
        let view = this;
        let raw_sectors = view.$store.getters["ProductData/getAllSectors"];
        let allowed_sectors = view.$store.getters["RawData/getAllowedSectors"];
        let filtered = [
          { sectorWorksiteVoluntary: "", text: "Select One", value: "" },
        ];
        if (raw_sectors.length) {
          raw_sectors.forEach((o) => {
            if (allowed_sectors.includes(o.value)) {
              filtered.push(o);
            }
          });
        }
        //console.log(filtered);
        return filtered;
      },
    },
    banner_product_path: {
      get: function () {
        var view = this;
        return view.$store.getters["ProductData/getBannerProductPath"];
      },
    },
    mobile_digital_file_type: {
      get: function () {
        var view = this;
        return view.$store.getters["ProductData/getMobileDigtialFileType"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setMobileDigtialFileType", o);
      },
    },
    mobile_digital_file_url: {
      get: function () {
        var view = this;
        return view.$store.getters["ProductData/getMobileDigtialFileURL"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setMobileDigtialFileURL", o);
      },
    },
    mobile_digital_file_size: {
      get: function () {
        var view = this;
        return view.$store.getters["ProductData/getMobileDigtialFileSize"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setMobileDigtialFileURL", o);
      },
    },

    entry_id: {
      get: function () {
        var view = this;
        return view.$store.getters["ProductData/getEntryId"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setEntryId", o);
      },
    },
    entry_date: {
      get: function () {
        var date = this.$store.getters["ProductData/getEntryDate"];
        let manual_date_changed =
          this.$store.getters["ProductData/getEntryDateChanged"];
        if (manual_date_changed == true) {
          return date;
        }

        let array = [];
        if (this.entry_id == "" || this.entry_id === undefined) {
          if (this.panelists.length > 0) {
            for (let i = 0; i < this.panelists.length; i++) {
              array.push(
                this.$store.getters["ProductData/getPanelists"][i].pp_date
              );
            }
            array.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
            date = array[0];
            //this.$store.dispatch("ProductData/setEntryDate", array[0]);
          }
          date = moment(date).format("YYYY-MM-DD hh:mm:ss");
          this.$store.dispatch("ProductData/setEntryDate", date);
        } else {
          date = this.entry_id.split("-");
          date = date[0] + "-" + date[1] + "-" + date[2];
          date = moment(date).format("YYYY-MM-DD hh:mm:ss");
          this.$store.dispatch("ProductData/setEntryDate", date);
        }
        return date;
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setEntryDate", o);
      },
    },
    product_comment: {
      get: function () {
        return this.$store.getters["ProductData/getProductComment"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductComment", o);
      },
    },
    pdf_content: {
      get: function () {
        var view = this;
        if (this.$store.getters["ProductData/getPdfContent"] !== null) {
          if (
            this.$store.getters["ProductData/getPdfContent"].split(" ").length >
            this.$c.pdf_content_settings.contentlength
          ) {
            view.content_limit_exceeded = true;
            view.display_content_text =
              this.$store.getters["ProductData/getPdfContent"];

            view.$store.dispatch("ProductData/setPdfContent", "");
          }
        }
        return this.$store.getters["ProductData/getPdfContent"] === null ||
          this.$store.getters["ProductData/getPdfContent"] == "null"
          ? ""
          : this.$store.getters["ProductData/getPdfContent"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPdfContent", o);
      },
    },
    primary_country: {
      get: function () {
        return this.$store.getters["ProductData/getPrimaryCountry"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPrimaryCountry", o);
      },
    },
    all_face_amount: function () {
      let state_all_face_amount =
        this.$store.getters["ProductData/getAllFaceAmount"];
      let dropdown = this.$utils.checkSectorExistInRawdata(
        this,
        state_all_face_amount,
        "face_amount"
      );
      return dropdown;
    },
    all_term_length: function () {
      let state_all_term_length =
        this.$store.getters["ProductData/getAllTermLength"];
      let dropdown = this.$utils.checkSectorExistInRawdata(
        this,
        state_all_term_length,
        "term_length"
      );
      return dropdown;
    },
    all_issue_types: function () {
      let state_all_issue_types =
        this.$store.getters["ProductData/getAllIssueTypes"];
      let dropdown = this.$utils.checkSectorExistInRawdata(
        this,
        state_all_issue_types,
        "issue_type"
      );
      return dropdown;
    },
    all_group_size: function () {
      let state_all_group_size =
        this.$store.getters["ProductData/getAllRawGroupSize"];
      let dropdown = this.$utils.checkSectorExistInRawdata(
        this,
        state_all_group_size,
        "group_size"
      );
      return dropdown;
    },
    all_riders: function () {
      let state_all_riders = this.$store.getters["ProductData/getAllRawRiders"];
      let dropdown = this.$utils.checkSectorExistInRawdata(
        this,
        state_all_riders,
        "riders"
      );
      return dropdown;
    },
    all_offer_origin: function () {
      //let view = this
      //let pc = view.$productConst
      let state_all_offer_origin =
        this.$store.getters["ProductData/getAllRawOfferOrigin"];
      let stateSector = this.$store.getters["ProductData/getSector"];
      let all_sectors_selected = [];
      if (stateSector.length == 0) {
        return [];
      } else {
        stateSector.forEach(function (o) {
          o.forEach(function (item) {
            all_sectors_selected.push(item.id.toString());
          });
        });
        //console.log(all_sectors_selected);
        let new_offers = [];
        new_offers.push({ text: "Select One", value: "" });
        state_all_offer_origin.forEach(function (e) {
          var common = all_sectors_selected.some(
            (r) => e.oo_sectorID.split(",").indexOf(r) >= 0
          );
          //console.log(common);
          if (common) {
            new_offers.push({ text: e.oo_name, value: e.oo_id });
          }
        });
        //console.log(new_offers);
        return new_offers;
      }
    },
    all_comm_type: function () {
      let state_all_communication_types =
        this.$store.getters["ProductData/getAllRawCommType"];
      let stateSector = this.$store.getters["ProductData/getSector"];
      let all_sectors_selected = [];
      let selected_audience = [];
      let temp_selected_audience =
        this.$store.getters["ProductData/getStateAudience"];
      selected_audience.push(temp_selected_audience.toString());
      //console.log(selected_audience);
      if (stateSector.length == 0) {
        return [];
      } else {
        stateSector.forEach(function (o) {
          o.forEach(function (item) {
            all_sectors_selected.push(item.id.toString());
          });
        });
      }
      let new_offers = [];
      state_all_communication_types.forEach(function (e) {
        if (e.sector_id != null && e.audience_id != null) {
          let common_sectors = all_sectors_selected.some(
            (r) => e.sector_id.split(",").indexOf(r) >= 0
          );
          let common_audience = selected_audience.some(
            (r) => e.audience_id.split(",").indexOf(r) >= 0
          );
          //console.log(e.type,common_sectors,common_audience);
          if (common_sectors && common_audience) {
            new_offers.push({ text: e.type, value: e.ID });
          }
        } else if (e.audience_id != null) {
          let common_audience = selected_audience.some(
            (r) => e.audience_id.split(",").indexOf(r) >= 0
          );
          if (common_audience) {
            new_offers.push({ text: e.type, value: e.ID });
          }
        } else if (e.sector_id != null) {
          let common_sectors = all_sectors_selected.some(
            (r) => e.sector_id.split(",").indexOf(r) >= 0
          );
          if (common_sectors) {
            new_offers.push({ text: e.type, value: e.ID });
          }
        } else {
          new_offers.push({ text: e.type, value: e.ID });
        }
      });
      //console.log(new_offers);
      return new_offers;
    },
    all_response_type: function () {
      let view = this;
      let pc = view.$productConst;
      let state_all_response_type =
        this.$store.getters["ProductData/getAllResponseType"];
      if (
        view.$utils.checkIfSectorIndexExist(view, pc.sector.insaurance, 0) ||
        view.$utils.checkIfSectorIndexExist(view, pc.sector.investment, 0)
      ) {
        return state_all_response_type;
      } else {
        let new_responses = state_all_response_type.filter(function (e) {
          return e.value != 1;
        });
        return new_responses;
      }
    },
    fee_product: {
      get: function () {
        return this.$store.getters["ProductData/getFeeProduct"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setFeeProduct", o);
      },
    },
    faux_check: {
      get: function () {
        return this.$store.getters["ProductData/getFauxCheck"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setFauxCheck", o);
      },
    },
    tip_on_card: {
      get: function () {
        return this.$store.getters["ProductData/getTipOnCard"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTipOnCard", o);
      },
    },
    handwriting: {
      get: function () {
        return this.$store.getters["ProductData/getHandwriting"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setHandwriting", o);
      },
    },
    gender: {
      get: function () {
        return this.$store.getters["ProductData/getGender"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setGender", o);
      },
    },
    citi: {
      get: function () {
        return this.$store.getters["ProductData/getCiti"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setCiti", o);
      },
    },
    offer_origin: {
      get: function () {
        if (this.$store.getters["ProductData/getOfferOrigin"] == 0)
          this.$store.dispatch("ProductData/setOfferOrigin", "");
        return this.$store.getters["ProductData/getOfferOrigin"] === 0
          ? ""
          : this.$store.getters["ProductData/getOfferOrigin"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setOfferOrigin", o);
      },
    },
    state_province: {
      get: function () {
        return this.$store.getters["ProductData/getStateProvince"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setStateProvince", o);
      },
    },
    ancillaryProducts: {
      get: function () {
        return this.$store.getters["ProductData/getAncillaryProducts"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setAncillaryProducts", o);
      },
    },
    groupSize: {
      get: function () {
        return this.$store.getters["ProductData/getGroupSize"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setGroupSize", o);
      },
    },
    faceAmount: {
      get: function () {
        return this.$store.getters["ProductData/getFaceAmount"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setFaceAmount", o);
      },
    },
    termLength: {
      get: function () {
        return this.$store.getters["ProductData/getTermLength"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTermLength", o);
      },
    },
    issueType: {
      get: function () {
        return this.$store.getters["ProductData/getIssueType"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setIssueType", o);
      },
    },
    riders: {
      get: function () {
        return this.$store.getters["ProductData/getRiders"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setRiders", o);
      },
    },
    audience: {
      get: function () {
        if (this.$store.getters["ProductData/getStateAudience"] == 0)
          this.$store.dispatch("ProductData/setAudience", "");
        return this.$store.getters["ProductData/getStateAudience"] === 0
          ? ""
          : this.$store.getters["ProductData/getStateAudience"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setAudience", o);
      },
    },
    media_channel: {
      get: function () {
        var view = this;

        // console.log(view.all_media_chan);

        let media_channel_name = view.all_media_chan
          .map((item) => {
            if (
              item.value ==
              this.$store.getters["ProductData/getStateMediaChannel"]
            ) {
              return item.text;
            }
          })
          .filter((value) => value !== undefined)
          .join("");
        if (media_channel_name !== undefined) {
          //@change_desc:refer to jira id:1278(changes done to capture channel name instead of id)
          this.$store.dispatch(
            "ProductData/setMediaChannelName",
            media_channel_name
          );
        }
        if (this.$route.query.channel_id !== undefined && this.$route.query.channel_id != 5) {
          this.$store.dispatch(
            "ProductData/setMediaChannel",
            this.$route.query.channel_id
          );
          return parseInt(this.$route.query.channel_id);
        } else {
          return this.$store.getters["ProductData/getStateMediaChannel"];
        }
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setMediaChannel", o);
        if (o == 3) {
          this.$store.dispatch("ProductData/setMediaChannelElectronicType", 1);
        }
      },
    },
    state_specific: {
      get: function () {
        return this.$store.getters["ProductData/getStateSpecific"];
      },
      set: function (o) {
        let view = this;
        this.$store.dispatch("ProductData/setStateSpecific", o);
        let state_specific =
          view.$store.getters["ProductData/getStateSpecific"];
        let selected_states =
          view.$store.getters["ProductData/getStateProvince"];
        // PATCH added for JIRAID-3335
        if (state_specific && this.checkDiff(selected_states)) {
          view.$swal.fire({
            position: "bottom-end",
            icon: "warning",
            title:
              "Warning: Panelist of different states are not allowed when state specific is checked!",
          });
        }
      },
    },
    offer_expiry_date: {
      set: function (o) {
        this.$store.dispatch("ProductData/setOfferExpiry", o);
      },
      get: function () {
        return this.$store.getters["ProductData/getOfferExpiry"];
      },
    },
    personalization: {
      get: function () {
        return this.$store.getters["ProductData/getPersonalization"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPersonalization", o);
      },
    },
    product_headline: {
      get: function () {
        // if(this.isDigitalMediaChannel()){
        //   return this.populateHeadline();
        // }else{
        //   return this.$store.getters["ProductData/getProductHeadline"];
        // }
        return this.$store.getters["ProductData/getProductHeadline"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductHeadline", o);
      },
    },
    product_name: {
      get: function () {
        return this.$store.getters["ProductData/getProductName"];
      },
      set: function (o) {
        let view = this;
        let pc = view.$productConst;
        this.$store.dispatch("ProductData/setProductName", o);
        if (o != "") {
          if (
            (this.media_channel === 5 ||
              this.media_channel === 10 ||
              this.media_channel === 9) &&
            view.$utils.checkFirstSectorIsCreditCard(
              view,
              pc.sector.credit_card
            )
          ) {
            this.populateHeadline();
          }
        }
      },
    },
    isPreScreen: {
      get: function () {
        return this.$store.getters["ProductData/getIsPrescreen"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setIsPrescreen", o);
      },
    },
    worksite_voluntary: {
      get: function () {
        return this.$store.getters["ProductData/getWorksiteVoluntary"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setWorksiteVoluntary", o);
      },
    },
    perscription: {
      get: function () {
        return this.$store.getters["ProductData/getPerscription"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPerscription", o);
      },
    },
    is_hphsa: {
      get: function () {
        return this.$store.getters["ProductData/getIsHphsa"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setIsHphsa", o);
      },
    },
    mailing_type: {
      get: function () {
        if (this.$store.getters["ProductData/getMailingType"] == 0)
          this.$store.dispatch("ProductData/setMailingType", "");
        return this.$store.getters["ProductData/getMailingType"] === 0
          ? ""
          : this.$store.getters["ProductData/getMailingType"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setMailingType", o);
      },
    },
    campaign_language: {
      get: function () {
        return this.$store.getters["ProductData/getCampaignLang"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setCampaignLang", o);
      },
    },
    communication_type: {
      get: function () {
        return this.$store.getters["ProductData/getCommunicationType"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setCommunicationType", o);
      },
    },
    business_content: {
      get: function () {
        return this.$store.getters["ProductData/getBusinessContent"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setBusinessContent", o);
      },
    },
    response_mechanism: {
      get: function () {
        return this.$store.getters["ProductData/getResponseMechanism"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setResponseMechanism", o);
      },
    },
    target_market: {
      get: function () {
        return this.$store.getters["ProductData/getTargetMarket"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setTargetMarket", o);
      },
    },
    varient_entry_id: {
      get: function () {
        return this.$store.getters["ProductData/getVarientEntryId"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setVarientEntryId", o);
      },
    },
    varient_type: {
      get: function () {
        return this.$store.getters["ProductData/getVariantType"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setVariantType", o);
      },
    },
    // sector: {
    //     get: function() {
    //         let view = this
    //         let stateSector = this.$store.getters['ProductData/getSector']
    //         if(stateSector != '' && stateSector !== undefined){
    //          this.$utils.setCategory(view,stateSector)
    //         }

    //         return stateSector
    //     },
    //     set: function(o) {
    //         let view = this
    //         this.$store.dispatch('ProductData/setSector', o)
    //         this.$utils.setCategory(view,o)
    //     },
    // },
    // category: {
    //     get: function() {
    //         let view = this
    //         let selectedCategory = this.$store.getters['ProductData/getSelectedCategory']
    //         if(selectedCategory != '' && selectedCategory !== undefined){
    //          this.$utils.setSubCategory(view,selectedCategory)
    //         }

    //         return selectedCategory
    //     },
    //     set: function(o) {
    //         let view = this
    //         this.$store.dispatch('ProductData/setSelectedCategory', o)
    //         this.$utils.setSubCategory(view,o)
    //     },
    // },
    // subCategory: {
    //     get: function() {
    //         let view = this
    //         let selectedSubCategory = this.$store.getters['ProductData/getSelectedSubCategory']
    //         if(selectedSubCategory != '' && selectedSubCategory !== undefined){
    //          this.$utils.setSubSubCategory(view,selectedSubCategory)
    //         }

    //         return selectedSubCategory
    //     },
    //     set: function(o) {
    //         let view = this
    //         this.$store.dispatch('ProductData/setSelectedSubCategory', o)
    //         this.$utils.setSubSubCategory(view,o)
    //     },
    // },
    // subSubCategory: {
    //     get: function() {
    //         return this.$store.getters['ProductData/getSelectedSubSubCategory']
    //     },
    //     set: function(o) {
    //         this.$store.dispatch('ProductData/getSelectedSubSubCategory', o)
    //     },
    // },
    product_age: {
      get: function () {
        return this.$store.getters["ProductData/getProductAge"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductAge", o);
      },
    },
    product_income: {
      get: function () {
        return this.$store.getters["ProductData/getProductIncome"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductIncome", o);
      },
    },
    observed_traffic_source: {
      get: function () {
        return this.$store.getters[
          "ProductData/getProductObservedTrafficSource"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductObservedTrafficSource", o);
      },
    },
    dm_tm_source: {
      get: function () {
        return this.$store.getters["ProductData/getProductDmTmSource"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setProductDmTmSource", o);
      },
    },
    is_deleted: {
      get: function () {
        return this.$store.getters["ProductData/getIsDeleted"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setIsDeleted", o);
      },
    },
    showSuggestionDialog(){
      return !!this.suggestionText?.trim()
    },
    mobileDigialPdfLink(){
      const a = this.current_pdf
      const b = this.pdf_cdn_link
      
      const aHttp = a?.startsWith('http://') || a?.startsWith('https://')
      const bHttp = b?.startsWith('http://') || b?.startsWith('https://')
      const nA = (a?.split('/').length??0)- 1
      const nB = (b?.split('/').length??0)- 1

      if(aHttp && bHttp){
        if(nA>3) return a
        if(nB>3) return b
      }else if(aHttp){
        if(nA>3) return a
        return `${a}${b}`
      }else if(bHttp){
        if(nB>3) return b
        return `${b}${a}`
      }
      return a || b || ""
    }
  },
  methods: {
    popUpWindow(title, icon) {
      this.$swal.fire({
        title: title,
        icon: icon,
        confirmButtonColor: "#1976d2 !important",
        confirmButtonText: "OK",
        width: "460px",
        customClass: {
          confirmButton: "swal-small-button",
        },
      });
    },
    getUXmedia: function (product_id) {
      let view = this;
      let product_status = view.$route.query.product_status;
      //    let endPoint = view.$url("UPLOAD_PRODUCT_PDF") + "?product_id=" + product_id + "&is_file=1&product_type=UxMedia" + "&product_status=" + product_status

      axios
        .get(this.$url("UPLOAD_PRODUCT_PDF"), {
          params: {
            product_id: product_id,
            product_type: "UxMedia",
            product_status: product_status,
          },
          headers: {
            Authorization: view.$utils.getAccessToken(),
            userid: view.$utils.getCookies("user_id"),
            roleid: view.$utils.getCookies("user_role"),
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("Request successful:", response.data);
          this.uxmediaData = response.data;

          view.$store.dispatch(
            "ProductData/setCurrentPdf",
            this.uxmediaData.file_path
          );
          view.$store.dispatch(
            "ProductData/setPdfContent",
            this.uxmediaData.pdf_text
          );
          view.$store.dispatch(
            "ProductData/setBannerProductPath",
            this.uxmediaData.banner_product_path
          );
          view.$store.dispatch(
            "ProductData/setDocumentSizeByte",
            this.uxmediaData.document_size_byte
          );
          view.$store.dispatch(
            "ProductData/setOriginalDocumentSize",
            this.uxmediaData.original_document_size
          );
          view.$store.dispatch(
            "ProductData/setIsMobileProduct",
            this.uxmediaData.is_mobile
          );
          view.$store.dispatch(
            "ProductData/setFileName",
            this.uxmediaData.filename
          );
          view.$store.dispatch(
            "ProductData/setPDFCDNLINK",
            this.uxmediaData.pdf_cdn_link
          );
          view.$store.dispatch(
            "ProductData/setPDFCDNLINKORIG",
            this.uxmediaData.pdf_cdn_link_orig
          );
          view.$store.dispatch(
            "ProductData/setDirectMailLogFile",
            this.uxmediaData.direct_mail_logfile
          );
        })
        .catch((error) => {
          console.error(
            "Request failed:",
            error.response ? error.response.data : error.message
          );
        });
    },

    isValidFileType(file) {
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/bmp",
        "image/webp",
        "image/svg+xml",
        "image/tiff",
        "application/pdf",
        "audio/mpeg",
        "audio/mp4",
        "audio/wav",
        "audio/ogg",
        "audio/x-m4a",
        "audio/flac",
        "video/mp4",
        "video/avi",
        "video/quicktime",
        "video/x-ms-wmv",
        "video/x-flv",
        "video/x-matroska",
        "video/webm",
      ];
      return validTypes.includes(file.type);
    },
    validateFile(file) {
      this.fileErrorMessages = [];

      if (!file) return;

      // Check file size (10MB limit)
      if (file.size > 100000000) {
        this.fileErrorMessages.push("File size exceeds 100MB limit");
      }

      // Validate file type
      if (!this.isValidFileType(file)) {
        this.fileErrorMessages.push("Invalid file type");
      }

      // Optional: Additional validation for specific file types
      if (file.type === "application/pdf") {
        // PDF-specific validation if needed
      } else if (file.type.startsWith("image/")) {
        // Image-specific validation if needed
      } else if (file.type.startsWith("video/")) {
        // Video-specific validation
        // if (file.size > 50000000) {
        //   this.fileErrorMessages.push("Video files should be less than 50MB");
        // }
      }
    },
    checkPanelistDate() {
      const panelistDate = this.$store.getters["ProductData/getPanelists"];

      if (!panelistDate) {
        return;
      }
      const dateArray = panelistDate.map((item) => item.pp_date.split(" ")[0]);
      dateArray.sort((a, b) => new Date(a) - new Date(b));
      if (dateArray.length > 0) {
        this.panelistIsPresent = false;
      } else {
        this.panelistIsPresent = true;
      }
      return dateArray;
    },
    debounceCheckPanelist: _.debounce(function () {
      this.checkPanelistDate();
    }, 300),
    moveAndDelete() {
      this.dialog = true;
    },
    toggleMoveDialog() {
      this.isMoveDialogOpen = !this.isMoveDialogOpen;
    },
    async searchEntryId() {
      this.isLoading = true;
      let productId = this.productId.trim();
      if (!productId) {
        this.isLoading = false;
        this.popUpWindow("Product ID cannot be empty.", "warning");
        return;
      }

      const requestData = {
        product_id: productId,
        entry_id: "",
      };
      const apiClient = axios.create({ baseURL: this.$url("API") });
      this.$utils.addAuthInterceptor(apiClient);
      try {
        let response = await apiClient.post("/move-and-delete", requestData);
        response = response.data;
        this.isLoading = false;
        if (response.status_code === 200) {
          const entryId = response.products?.entry_id;
          if (entryId?.length > 0) {
            this.entryId = entryId;
            this.productId = "";
          } else {
            this.popUpWindow(
              `Entry Id not found for product ID: ${productId}`,
              "error"
            );
          }
        } else {
          this.popUpWindow(
            `${response.message} for product ID: ${productId}`,
            "error"
          );
          this.productId = "";
        }
      } catch (error) {
        this.isLoading = false;
        this.popUpWindow("An error occurred while fetching data.", "error");
      }
    },

    async handleNextButton() {
      let entryId = this.entryId.trim();
      let sortPanelistDate = this.checkPanelistDate();
      let validEntryId = entryId.match(
        /\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
      );
      if (entryId.length === 0) {
        this.isLoading = false;
        let title = "Entry ID cannot be empty.";
        let icon = "warning";
        this.popUpWindow(title, icon);
        return;
      }
      if (!validEntryId) {
        let title = "Please enter a valid date format";
        let icon = "error";
        this.popUpWindow(title, icon);
        return;
      }

      const targetDate = new Date(validEntryId[0]);
      const sourceDate = new Date(sortPanelistDate[0]);

      if (targetDate > sourceDate) {
        let title = `Panelist date ${sortPanelistDate[0]} cannot be older than Entry Date ${validEntryId[0]}`;
        let icon = "error";
        this.popUpWindow(title, icon);
        this.clearFields();
        this.secondDialog = false;
        return;
      } else {
        const requestData = { target_entry_id: entryId };

        const apiClient = axios.create({ baseURL: this.$url("API") });
        this.$utils.addAuthInterceptor(apiClient);
        try {
          this.isLoading = true;
          let response = await apiClient.post("/move-and-delete", requestData);
          this.isLoading = false;
          if (!response.data) {
            this.popUpWindow("Product details not found ", "error");
            this.clearFields();
            return;
          }
          response = response.data;
          if (response.status_code === 200) {
            this.isLoading = false;
            this.secondDialog = true;
            this.dialog = false;
          } else {
            this.isLoading = false;
            this.popUpWindow(response.message, "error");
          }
        } catch (e) {
          this.popUpWindow(e, "error");
        }
      }

      this.panelistIsPresent = false;
      return;
    },
    async confirmMove() {
      this.isLoading = true;
      let entryId = this.entryId.trim();
      // let validTargetEntryDate = this.sourceEntryDate.match(/\d{4}-\d{2}-\d{2}/)
      let validEntryId = entryId.match(/\d{4}-\d{2}-\d{2}/);
      if (!validEntryId) {
        this.isLoading = false;
        let title = "Please enter a valid date format";
        let icon = "error";
        this.popUpWindow(title, icon);
        this.panelistIsPresent = false;
        this.secondDialog = false;
        this.clearFields();
        return;
      }
      let requestData = {};
      if (entryId.length > 0) {
        requestData = {
          // state_specific:this.state_specific,
          target_entry_id: entryId,
          source_product_id: toInteger(this.product_id),
        };
        const apiClient = axios.create({ baseURL: this.$url("API") });
        this.$utils.addAuthInterceptor(apiClient);
        let response = await apiClient.post("/move-and-delete", requestData);
        response = response.data;
        if (response) {
          this.isLoading = false;
          this.successMoved = response.status;
          if (response.status_code == 200) {
            let title = `Product move and deleted successfully`;
            let icon = "success";
            this.popUpWindow(title, icon);
          } else if (response.status_code == 404) {
            let title = response.message;
            let icon = "warning";
            this.popUpWindow(title, icon);
          } else {
            let title = response.message;
            let icon = "error";
            this.popUpWindow(title, icon);
          }
          this.secondDialog = false;
          this.isLoading = false;
          this.clearFields();
        }
      }
    },
    handleCancelButton() {
      this.dialog = false;
      this.secondDialog = false;
      this.clearFields();
    },
    clearFields() {
      this.entryId = "";
      this.productId = "";
    },
    updateButtonState(progress) {
      var progress = Math.round(progress);
      if (progress >= 0 && progress < 100) {
        this.disable_all_buttons = true;
      } else if (progress === 100) {
        this.disable_all_buttons = false;
      }
    },
    checkProgress() {
      if (this.$refs.topProgress) {
        this.updateButtonState(this.$refs.topProgress.progress);
      }
    },
    duplicate_headline(producheadline) {
      let view = this;
      view.duplicate_headline_status = false;
      view.duplicate_headline_text = "";
      let post_data = {
        product_headline: producheadline,
      };
      if (producheadline) {
        view
          .$fetch(
            {
              //https://api7.competiscan.com/product/v1/
              url: view.$url("API") + "get_product_headline",
              type: "POST",
              data: JSON.stringify(post_data),
              contentType: "application/json",
            },
            {
              operation: "",
              vueScope: view,
            }
          )
          .then((response) => {
            if (response.status_code == 200) {
              view.duplicate_headline_status = Boolean(
                response.product_headline_exist
              );
              //console.log(view.duplicate_headline_status)
              if (view.duplicate_headline_status) {
                document.getElementById("headline_alert").style.display =
                  "block";
              } else {
                document.getElementById("headline_alert").style.display =
                  "none";
              }

              view.duplicate_headline_text = response.request.product_headline;
            }
          })
          .catch(function (e) {
            console.log(e);
          });
      }
    },
    //Changes Link to JID-2023
    sendEmail(value) {
      if (value) this.sendemaildialog = false;
    },
    //Changes Link to JID-2023
    cancelEmail(value) {
      var view = this;
      view.sendemaildialog = false;
      console.log(value);
    },
    //Changes Link to JID-2023
    opensendemailmodal() {
      var view = this;
      view.sendemaildialog = true;
    },
    deleteProduct: function () {
      var view = this;
      // let archieve_link = view.$url("PRODUCT_ARCHIEVE_LINK");
      let product_id = view.product_id;
      let es_index_name = "";
      const d = new Date(view.$store.getters["ProductData/getAddedToDatabase"]);
      //console.log(es_index_name);
      let year = d.getFullYear();
      es_index_name = "products_" + year;

      this.$swal
        .fire({
          title: "Are you sure ?",
          text: "This will remove product temporarily.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, remove it !",
          cancelButtonText: "No, cancel !",
          closeOnConfirm: false,
          closeOnCancel: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            var posted_data = {};
            var data = [];
            let local = {};
            local["product_id"] = product_id;
            local["index_name"] = es_index_name;
            data.push(local);
            posted_data["data"] = data;
            let delelete_endpoint = view.$url("SOFT_DELETE");
            view
              .$fetch(
                {
                  url: delelete_endpoint,
                  type: "POST",
                  data: JSON.stringify(posted_data),
                  contentType: "application/json",
                },
                {
                  operation: "delete",
                  vueScope: view,
                }
              )
              .then((response) => {
                console.log(response);
                this.$swal.fire({
                  icon: "success",
                  title: "Product Deleted",
                  text: "Product has been deleted successfully",
                });

                view.after_submit_msg =
                  view.product_id + " Deleted successfully.";
                view.after_submit = true;
              })
              .catch(function (response) {
                console.log(response);
              });

            view.selected = [];
            // console.log(JSON.stringify(posted_data));
            // delete endpoint
          } else {
            view.selected = [];
          }
        });
    },
    download_file: function () {
      var view = this;
      this.product_id;
      let endpoint =
        view.$url("DOWNLOAD_FILE") + "?product_id=" + this.product_id;
      //console.log(endpoint);
      window.location.href = endpoint;
    },
    download_org_file: function () {
      var view = this;
      this.product_id;
      let endpoint =
        view.$url("DOWNLOAD_FILE") +
        "?product_id=" +
        this.product_id +
        "&type=original";
      window.location.href = endpoint;
    },
    formateDate: function (d) {
      return this.$utils.formateDate(d);
    },
    openlogmodal() {
      var view = this;
      view.productadmindialog = true;
      view.isLoading = true;
      view.loading = true;
      view.logdata = [];
      let logurl =
        view.$url("PRODUCT_ADMIN_LOG") +
        "/" +
        view.product_id +
        "?type=process";
      // alert(logurl)
      // let token = view.$utils.getAccessToken();
      this.$fetch(
        {
          url: logurl,
          type: "GET",
          contentType: "application/json",
        },
        {
          operation: "add",
          vueScope: view,
        }
      )
        .then((response) => {
          view.isLoading = false;
          view.loading = false;
          // console.log(response);
          view.logdata = response.payload;
          // console.log(view.logdata);
          view.logmuid = view.muid;
        })
        .catch(function (response) {
          // console.log(response);
          if (response.response.status == 401) {
            view.loading = false;
            window.location.href;
          }
        });
    },
    open_media_url: function () {
      let filename = this.$store.getters["ProductData/getFileName"];
      let media_type = "";
      if (filename != "")
        if (filename.split(".")[filename.split(".").length - 1] != "pdf")
          media_type = "?mediatype=showimage";
      let file_url = this.mobile_digital_file_url + media_type;

      window.open(file_url, "managepreview", "width=800,height=500");
      window.focus();
    },

    checkFile: function () {
      //view.$store.dispatch("ProductData/setPdfContent", "");
    },
    isDigitalMediaChannel() {
      if (
        this.media_channel === 5 ||
        this.media_channel === 10 ||
        this.media_channel === 9
      ) {
        return true;
      } else {
        return false;
      }
    },
    populateHeadlinev2() {
      let headline = "";
      let sector_name = "";
      let view = this;
      let pc = view.$productConst;
      let company_name = "";
      let product_name = this.$store.getters["ProductData/getProductName"];
      if (this.companies.length) {
        company_name = this.companies[0].companyName;
      }

      let sectors = view.$store.getters["ProductData/getSector"];

      if (view.isDigitalMediaChannel()) {
        if (
          view.$utils.checkFirstSectorIsCreditCard(view, pc.sector.credit_card)
        ) {
          headline =
            product_name +
            " " +
            this.$store.getters["ProductData/getMediaChannelName"] +
            " advertisement from " +
            company_name;
        } else {
          if (sectors.length) {
            sector_name = sectors[0][sectors[0].length - 1].name;
          }
          headline =
            sector_name +
            " " +
            this.$store.getters["ProductData/getMediaChannelName"] +
            " advertisement from " +
            company_name;
        }
        this.$store.dispatch("ProductData/setProductHeadline", headline);
      }
    },
    populateHeadline() {
      let headline = "";
      let sector_name = "";
      let view = this;
      let pc = view.$productConst;
      let company_name = "";
      let product_name = this.$store.getters["ProductData/getProductName"];
      if (this.companies.length) {
        company_name = this.companies[0].companyName;
      }
      // else{
      //   if(clicked === true){
      //     view.$swal.fire({
      //       position: "bottom-end",
      //       icon: "error",
      //       title: "Please add companies!",
      //       });
      //   return ''
      //   }
      // }
      let sectors = view.$store.getters["ProductData/getSector"];
      //console.log(sectors.length);
      // if(sectors.length == 0 && this.watchsectors == ''){
      //   if(clicked === true){
      //     view.$swal.fire({
      //       position: "bottom-end",
      //       icon: "error",
      //       title: "Please add sectors!",
      //       });
      //       return ''
      //   }
      // }
      if (
        view.$utils.checkFirstSectorIsCreditCard(view, pc.sector.credit_card)
      ) {
        // if(product_name == ''){
        //   view.$swal.fire({
        //     position: "bottom-end",
        //     icon: "error",
        //     title: "Please add product name!",
        //     });
        //     return ''
        // }
        headline =
          product_name +
          " " +
          this.$store.getters["ProductData/getMediaChannelName"] +
          " advertisement from " +
          company_name;
      } else {
        //console.log("sectorsss length", sectors.length);
        if (sectors.length) {
          //console.log("sectorsss", sectors[0][sectors[0].length - 1].name);
          sector_name = sectors[0][sectors[0].length - 1].name;
        }
        headline =
          sector_name +
          " " +
          this.$store.getters["ProductData/getMediaChannelName"] +
          " advertisement from " +
          company_name;
      }
      //return headline
      this.$store.dispatch("ProductData/setProductHeadline", headline);
    },
    /** common function to get data */
    check_banner_product(view, url) {
      // let product_status = this.$route.query.product_status
      // var endPoint = view.$url("VIEW_PDF_IMAGES")+"?product_id="+product_id+"&product_type=MobileProduct&product_status="+product_status
      view
        .$fetch(
          {
            url: url,
            type: "GET",
            contentType: "application/json",
          },
          {
            operation: "add",
            vueScope: view,
          }
        )
        .then(function (r) {
          view.is_banner_product = r.payload.status;
        });
    },

    showPdfText: function () {
      var view = this;
      view.pdftextdialog = true;
    },
    showpdfcontent_textarea: function () {
      var view = this;
      view.showpdfcontent = view.showpdfcontent == true ? false : true;
    },
    productSuccessSubmit: function () {
      this.after_submit = false;

      parent.window.close();
      window.close();
    },

    open_process_pdf() {
      var view = this;
      var muid = view.$store.getters["ProductData/getMuid"];
      view.tmp_pdf_click = true;

      window.open(
        view.$url("RENDER_PDF") + muid,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800"
      );
    },
    open_directmail_pdf() {
      var view = this;
      var product_id = view.product_id;
      view.tmp_pdf_click = true;
      let url =
        view.$url("DIRECT_MAIL_PDF_URL") +
        "?product_id=" +
        product_id +
        "&pdf_type=orignal";
      url = url.replace(/%20/g, " ");

      window.open(
        url,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800"
      );
    },
    open_product_pdf(product_id) {
      var view = this;
      product_id = view.$store.getters["ProductData/getProductId"];
      let url = view.$url("DIRECT_MAIL_PDF_URL") + "?product_id=" + product_id;
      url = url.replace(/%20/g, " ");

      window.open(
        url,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800"
      );
    },
    open_product_media(product_id) {
      var view = this;
      product_id = view.$store.getters["ProductData/getProductId"];
      if (view.media_channel == 6) {
        product_id = view.muid;
      }
      let url =
        view.$url("DIRECT_MAIL_PDF_URL") +
        "?product_id=" +
        product_id +
        "&is_pdf=0";
      url = url.replace(/%20/g, " ");

      window.open(
        url,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800"
      );
    },
    open_image(mobile_digital_file_url) {
      window.open(
        mobile_digital_file_url,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800"
      );
    },
    manage_pdf(product_id) {
      var view = this;
      view.$store.getters["ProductData/getProductId"];

      product_id = view.$store.getters["ProductData/getProductId"];
      let url = "../managepdf/" + product_id;
      url = url.replace(/%20/g, " ");
      if (view.$route.name == "addproduct-v2")
        url = "../../managepdf/" + product_id;

      window.open(
        url,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800"
      );
    },
    mobile_digital_image_preview(productId, productStatus) {
      let url = `/mobilepreview/${productId}&product_status=${productStatus}`;
      window.open(
        url,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=400"
      );
    },
    mobile_digital_preview(url) {
      window.open(
        url,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=400"
      );
    },
    open_mobile_digital_product(url) {
      window.open(
        url,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=100,,width=800,height=800"
      );
    },

    open_uploaded_pdf() {
      var view = this;
      var muid = view.muid;
      view.tmp_pdf_click = true;

      window.open(
        view.$url("UPLOAD_PRODUCT_PDF") + "?product_id=" + muid,
        "_blank"
      );
    },
    upload_product_pdf() {
      if (!this.fileErrorMessages.length > 0) {
        let product_id = this.product_id;
        product_id = product_id === undefined ? "" : product_id;
        var view = this;
        let user_role = view.$utils.getCookies("user_role");
        view.disable_all_buttons = true;
        view.product_pdf_file_uploaded = false;
        let formData = new FormData();
        this.pdf_destination =
          view.$c.base_document_path.name + product_id + "";
        this.img_destination =
          view.$c.base_document_path.name + product_id + "/productImages/";
        let token = view.$utils.getAccessToken();
        let current_active_module =
          view.$store.getters["RawData/getCurrentActiveModule"];
        let user_id = view.$utils.getCookies("user_id");
        if (this.product_pdf === null) {
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: "Please Upload Product Pdf",
          });
        } else {
          formData.append("file", this.product_pdf);
          formData.append("destination", this.pdf_destination);
          formData.append("img_destination", this.img_destination);
          formData.append("product_id", product_id);
          view.progressBar = true;
          view.disable_all_buttons = true;
          view.upload_button_click = true;

          let upload_endpoint = view.$url("UPLOAD_SERVICE_URL");
          //let upload_endpoint = "http://0.0.0.0:5417/product-upload";
          // upload percent and speed
          let startTime = new Date().getTime();
          const config = {
            onUploadProgress: (progressEvent) => {
              view.downloadPer = Math.floor(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              view.transfer_rate = (
                progressEvent.loaded /
                ((new Date().getTime() - startTime) / 1000) /
                1024 /
                1024
              ).toFixed(2);
            },
            headers: {
              moduleid: current_active_module,
              userid: user_id,
              roleid: user_role,
              Authorization: token,
              "Content-Type": "multipart/form-data",
            },
          };
          ////

          axios.post(upload_endpoint, formData, config).then((response) => {
            view.disable_all_buttons = false;
            view.uploaded_pdf_filename = response.data.filename;
            view.file_upload_msg = "File Uploaded Successfully";
            view.product_id = response.data.product_id;
            view.$store.dispatch(
              "ProductData/setProductId",
              response.data.product_id
            );
            view.$store.dispatch("ProductData/setPdfContent", "");
            view.pdf_destination =
              view.$c.base_document_path.name + view.product_id + "";
            view.img_destination =
              view.$c.base_document_path.name +
              view.product_id +
              "/productImages/";

            view.progressBar = false;
          });
        }
      } else {
        this.$swal.fire({
          position: "center",
          icon: "error",
          title: "cannot upload this file format",
        });
      }
    },
    checkStateSpecifcCompanyOrNot(selected_states) {
      let noOfStates = 0;
      this.companyStates = [];
      if (
        this.companies[0] &&
        this.companies[0].co_states.length > 0 &&
        selected_states.length > 0
      ) {
        let co_states = this.companies[0].co_states;
        let st = this.states;
        co_states = co_states.trim().split(",");
        for (let j = 0; j < co_states.length; j++) {
          for (let i = 0; i < st.length; i++) {
            if (st[i].value.toString() === co_states[j].trim()) {
              this.companyStates.push(st[i].text);
            }
          }
        }
        let state_companies = this.companies[0].co_states.replace(/ +/g, "");
        state_companies = state_companies.split(",");
        // state_companies.sort((a, b) => (a > b ? -1 : 1));
        for (var i = 0; i < selected_states.length; i++) {
          // console.log("Now", typeof(state_companies), state_companies);
          if (
            !state_companies.includes(selected_states[i].toString()) &&
            selected_states[i] !== 0
          ) {
            noOfStates = noOfStates + 1;
          }
        }
        if (noOfStates > 0 && !this.companies_state_species) {
          this.companies_state_species = true;
          return true;
        } else {
          this.companies_state_species = false;
          return false;
        }
      }
    },
    closeStateSpecificDialog(e) {
      var view = this;
      if (e) {
        view.companies_state_species = true;
        switch (view.btnClick) {
          case "approved":
            view.approved();
            break;
          case "unapproved":
            view.unapproved();
            break;
          case "problem":
            view.problem();
            break;
          case "reprocessed":
            view.reprocessed();
            break;
          case "submit":
            view.submit();
            break;
        }
      } else {
        view.companies_state_species = false;
      }
      view.btnClick = "";
      view.companies_state_modal = false;
    },
    approved: function () {
      var view = this;
      if (!view.futureDateSelected) {
        view.file_upload_msg = "";
        view.btnClick = "approved";
        var validationMsg = view.$utils.validateProduct(view);
        var validationMsgapproved = view.$utils.validateProductapproved(view);
        // validationMsg = validationMsg.concat(validationMsgapproved)
        //alert(view.current_pdf_filename)
        let state_specific =
          view.$store.getters["ProductData/getStateSpecific"];
        let selected_states =
          view.$store.getters["ProductData/getStateProvince"];
        let entry_date = view.$store.getters["ProductData/getEntryDate"];
        let panelists = view.$store.getters["ProductData/getPanelists"];
        let offer_expiry_date =
          view.$store.getters["ProductData/getOfferExpiry"];
        const minDate = new Date(
          Math.min(
            ...panelists.map((element) => {
              return new Date(element.pp_date);
            })
          )
        );
           // Check for panelist date mismatch if ec_content_type is 'direct'
    if (
      this.$route.query.ec_content_type === "direct" &&
      panelists.some(p => {
        const panelistDate = p.pp_date?.split(/[T ]/)[0];
        const entryDateOnly = entry_date?.split(/[T ]/)[0];
        return panelistDate !== entryDateOnly;
      })
    ) {
      this.$swal.fire({
        position: "center",
        icon: "error",
        title: "Panelist Date Mismatch",
        text: `Panelist dates must match Entry Date: ${moment(entry_date).format("YYYY-MM-DD")}`,
      });
      return false;
    }
        if (state_specific && this.checkDiff(selected_states)) {
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Panelist of different states are not allowed when state specific is checked!",
          });
        } else if (
          Date.parse(moment(offer_expiry_date).format("YYYY-MM-DD")) <
          Date.parse(moment(entry_date).format("YYYY-MM-DD"))
        ) {
          this.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Offer Expiry date " +
              moment(offer_expiry_date).format("YYYY-MM-DD") +
              " cannot be older than Entry Date " +
              moment(entry_date).format("YYYY-MM-DD"),
          });
          return false;
        } else if (
          Date.parse(moment(minDate).format("YYYY-MM-DD")) <
          Date.parse(moment(entry_date).format("YYYY-MM-DD"))
        ) {
      
          return false;
        } else {
          if (
            (Array.isArray(validationMsg) && validationMsg.length) ||
            (Array.isArray(validationMsgapproved) &&
              validationMsgapproved.length)
          ) {
            view.confirm_submit = true;
            view.confirm_submit_text = validationMsg;
            view.confirm_submit_text_approved = validationMsgapproved;
          } else if (view.current_pdf_filename != "") {
            if (view.product_pdf != null) {
              if (view.uploaded_pdf_filename == "") {
                view.$swal.fire({
                  position: "bottom-end",
                  icon: "error",
                  title:
                    "File not uploaded.Please click upload button to upload file ",
                });
              } else {
                this.$store.dispatch("ProductData/setProductStatus", 1);
                this.send();
              }
            } else {
              this.$store.dispatch("ProductData/setProductStatus", 1);
              this.send();
            }
          } else {
            if (
              view.product_pdf == null &&
              view.use_same_process_pdf == false
            ) {
              //check if media content is mobile digital or not
              if (view.$route.query.ec_content_type == "mobiledigital") {
                this.$store.dispatch("ProductData/setProductStatus", 1);
                this.send();
              } else {
                view.$swal.fire({
                  position: "bottom-end",
                  icon: "error",
                  title: "Please Upload Product Pdf",
                });
              }
            } else if (
              view.product_pdf != null &&
              view.use_same_process_pdf == true
            ) {
              view.$swal.fire({
                position: "bottom-end",
                icon: "error",
                title:
                  "Please Choose one option from Upload Product Pdf or Process Pdf Option",
              });
            } else {
              this.$store.dispatch("ProductData/setProductStatus", 1);
              // this.upload_product_pdf(this.product_id)
              // Fixed done for 2282
              //block for manual product
              if (
                view.$route.query.channel_id !== undefined &&
                view.$route.query.channel_id != ""
              ) {
                if (view.product_pdf === null) {
                  view.$swal.fire({
                    position: "bottom-end",
                    icon: "error",
                    title: "Please upload product PDF",
                  });
                } else {
                  if (view.uploaded_pdf_filename == "") {
                    view.$swal.fire({
                      position: "bottom-end",
                      icon: "error",
                      title:
                        "File not uploaded.Please click upload button to upload file ",
                    });
                  } else {
                    this.send();
                  }
                }
              } else {
                //block for publish all product except manual
                if (view.current_pdf_path != "") {
                  if (view.uploaded_pdf_filename == "") {
                    view.$swal.fire({
                      position: "bottom-end",
                      icon: "error",
                      title:
                        "File not uploaded.Please click upload button to upload file  ",
                    });
                  } else {
                    this.send();
                  }
                } else {
                  if (view.product_pdf !== null) {
                    if (view.uploaded_pdf_filename == "") {
                      view.$swal.fire({
                        position: "bottom-end",
                        icon: "error",
                        title:
                          "File not uploaded.Please click upload button to upload file  ",
                      });
                    } else {
                      this.send();
                    }
                  } else {
                    this.send();
                  }
                }
              }
            }
          }
        }
      } else {
        view.$swal.fire({
          position: "center",
          title: "Invalid date: Panelist date cannot be in the future.",
          icon: "error",
        });
      }
    },
    checkDiff: function (arr) {
      // PATCH added for JIRAID-3335
      return !arr.every((e) => e == arr[0]);
    },
    unapproved: function () {
      var view = this;
      if (!view.futureDateSelected) {
        view.file_upload_msg = "";
        view.confirm_submit_text_approved = "";
        view.btnClick = "unapproved";
        var validationMsg = view.$utils.validateProduct(view);
        //view.$store.dispatch('ProductData/setProductStatus',4)
        let state_specific =
          view.$store.getters["ProductData/getStateSpecific"];
        let selected_states =
          view.$store.getters["ProductData/getStateProvince"];
        // PATCH added for JIRAID-3335
        let entry_date = view.$store.getters["ProductData/getEntryDate"];
        let panelists = view.$store.getters["ProductData/getPanelists"];
        let offer_expiry_date =
          view.$store.getters["ProductData/getOfferExpiry"];
        const minDate = new Date(
          Math.min(
            ...panelists.map((element) => {
              return new Date(element.pp_date);
            })
          )
        );
        if (state_specific && this.checkDiff(selected_states)) {
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Panelist of different states are not allowed when state specific is checked!",
          });
        } else if (
          Date.parse(moment(offer_expiry_date).format("YYYY-MM-DD")) <
          Date.parse(moment(entry_date).format("YYYY-MM-DD"))
        ) {
          this.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Offer Expiry date " +
              moment(offer_expiry_date).format("YYYY-MM-DD") +
              " cannot be older than Entry Date " +
              moment(entry_date).format("YYYY-MM-DD"),
          });
          return false;
        } else if (
          Date.parse(moment(minDate).format("YYYY-MM-DD")) <
          Date.parse(moment(entry_date).format("YYYY-MM-DD"))
        ) {
          this.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Panelist date " +
              moment(minDate).format("YYYY-MM-DD") +
              " cannot be older than Entry Date " +
              moment(entry_date).format("YYYY-MM-DD"),
          });
          return false;
        } else if (Array.isArray(validationMsg) && validationMsg.length) {
          view.confirm_submit = true;
          view.confirm_submit_text = validationMsg;
        } else {
          if (view.product_pdf != null) {
            if (view.uploaded_pdf_filename == "") {
              view.$swal.fire({
                position: "bottom-end",
                icon: "error",
                title:
                  "File not uploaded.Please click upload button to upload file ",
              });
            } else {
              view.$store.dispatch("ProductData/setProductStatus", 2);
              this.send();
            }
          } else {
            view.$store.dispatch("ProductData/setProductStatus", 2);
            this.send();
          }
        }
      } else {
        view.$swal.fire({
          position: "center",
          title: "Invalid date: Panelist date cannot be in the future.",
          icon: "error",
        });
      }
    },
    problem: function () {
      var view = this;
      if (!view.futureDateSelected) {
        view.file_upload_msg = "";
        view.confirm_submit_text_approved = "";
        view.btnClick = "problem";
        var validationMsg = view.$utils.validateProduct(view);
        //view.$store.dispatch('ProductData/setProductStatus',4)
        let state_specific =
          view.$store.getters["ProductData/getStateSpecific"];
        let selected_states =
          view.$store.getters["ProductData/getStateProvince"];
        // PATCH added for JIRAID-3335
        let entry_date = view.$store.getters["ProductData/getEntryDate"];
        let panelists = view.$store.getters["ProductData/getPanelists"];
        let offer_expiry_date =
          view.$store.getters["ProductData/getOfferExpiry"];

        const minDate = new Date(
          Math.min(
            ...panelists.map((element) => {
              return new Date(element.pp_date);
            })
          )
        );

        if (state_specific && this.checkDiff(selected_states)) {
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Panelist of different states are not allowed when state specific is checked!",
          });
        } else if (
          Date.parse(moment(offer_expiry_date).format("YYYY-MM-DD")) <
          Date.parse(moment(entry_date).format("YYYY-MM-DD"))
        ) {
          this.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Offer Expiry date " +
              moment(offer_expiry_date).format("YYYY-MM-DD") +
              " cannot be older than Entry Date " +
              moment(entry_date).format("YYYY-MM-DD"),
          });
          return false;
        } else if (
          Date.parse(moment(minDate).format("YYYY-MM-DD")) <
          Date.parse(moment(entry_date).format("YYYY-MM-DD"))
        ) {
          this.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Panelist date " +
              moment(minDate).format("YYYY-MM-DD") +
              " cannot be older than Entry Date " +
              moment(entry_date).format("YYYY-MM-DD"),
          });
          return false;
        } else if (Array.isArray(validationMsg) && validationMsg.length) {
          view.confirm_submit = true;
          view.confirm_submit_text = validationMsg;
        } else if (this.product_comment == "" || this.product_comment == null) {
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title: "Please Enter Comment",
          });
        } else {
          if (view.product_pdf != null) {
            if (view.uploaded_pdf_filename == "") {
              view.$swal.fire({
                position: "bottom-end",
                icon: "error",
                title:
                  "File not uploaded.Please click upload button to upload file ",
              });
            } else {
              view.$store.dispatch("ProductData/setProductStatus", 4);
              this.send();
            }
          } else {
            view.$store.dispatch("ProductData/setProductStatus", 4);
            this.send();
          }
        }
      } else {
        view.$swal.fire({
          position: "center",
          title: "Invalid date: Panelist date cannot be in the future.",
          icon: "error",
        });
      }
    },

    chooseProductName: function (o) {
      var view = this;
      view.$store.dispatch("ProductData/setProductName", o);
      view.searchProductNames = "";
      view.product_names = [];
      this.populateHeadlinev2();
    },
    getSectorBasedDropdown(stateSector, raw_data, dropdown_type) {
      let all_sectors_selected = [];
      if (stateSector.length == 0) {
        return [];
      } else {
        stateSector.forEach(function (o) {
          o.forEach(function (item) {
            all_sectors_selected.push(item.id.toString());
          });
        });
        //console.log(all_sectors_selected);
        let new_dropdown = [];
        raw_data.forEach(function (e) {
          if (dropdown_type == "face_amount") {
            let common = all_sectors_selected.some(
              (r) => e.sector_id.split(",").indexOf(r) >= 0
            );
            if (common) {
              new_dropdown.push({ text: e.fa_name, value: e.fa_id });
            }
          }
          if (dropdown_type == "term_length") {
            let common = all_sectors_selected.some(
              (r) => e.sector_id.split(",").indexOf(r) >= 0
            );
            if (common) {
              new_dropdown.push({ text: e.tl_name, value: e.tl_id });
            }
          }
          if (dropdown_type == "issue_type") {
            let common = all_sectors_selected.some(
              (r) => e.sector_id.split(",").indexOf(r) >= 0
            );
            if (common) {
              new_dropdown.push({
                text: e.IssueTypeName,
                value: e.IssueTypeID,
              });
            }
          }
          // console.log(new_dropdown);
        });
        return new_dropdown;
      }
    },
    toggleDemoGraphicInfo() {
      this.toggle_sector_divs.demographic_info =
        !this.toggle_sector_divs.demographic_info;
    },
    toggleAddPanelist() {
      this.showeditpanelist = false;
      this.openPanelist = !this.openPanelist;
    },
    clearOfferDate() {
      this.$store.dispatch("ProductData/setOfferExpiry", null);
    },
    chooseAffinity: function (o) {
      let stateAffinity = this.$store.getters["ProductData/getAffinity"];
      let dup = stateAffinity.filter((c) => o.affinityID === c.affinityID);
      if (parseInt(dup.length) === parseInt(0)) {
        stateAffinity.push(o);
      }
      this.$store.dispatch("ProductData/setAffinity", stateAffinity);
      this.openAffinityAssociation = false;
    },
    closeAffinityAssociation: function (e) {
      this.openAffinityAssociation = e;
    },
    manageCompany: function () {
      let route = this.$router.resolve({
        name: "company",
        params: { muid: this.muid },
      });
      window.open(route.href, "_blank");
    },
    // showPdf: function () {
    //   window.open(this.$url('HTML_PDF_SERVICE')+"temppdf/"+this.muid);
    // },
    // showHtml: function () {
    //   window.open(this.$url('HTML_PDF_SERVICE')+"processedhtml/"+this.muid);
    // },
    showHtml: function () {
      var view = this;
      window.open(
        view.$url("HTML_PDF_SERVICE") + "processedhtml/" + view.muid,
        "emailhtmlpopup",
        "width=800,height=500"
      );
      window.focus();
    },
    showPdf: function () {
      var view = this;
      window.open(
        view.$url("HTML_PDF_SERVICE") + "temppdf/" + view.muid,
        "emailpdfpopup",
        "width=800,height=500"
      );
      window.focus();
    },
    closePanelist: function (e) {
      this.openPanelist = e;
    },
    updateSubmittableSectors: function (payload) {
      let view = this;
      let pc = view.$productConst;
      if (Array.isArray(payload) && payload.length) {
        view.$store.dispatch("ProductData/setSectorsDisplayData", payload);
        let sectorsSubmittablePayload = [];
        payload.forEach((item) => {
          let newCombination = [];
          item.forEach((o) => {
            if (o.id) {
              newCombination.push(o.id);
            }
          });
          sectorsSubmittablePayload.push(newCombination);
        });
        view.$store.dispatch(
          "ProductData/setSectorsSubmittable",
          sectorsSubmittablePayload
        );
      } else {
        view.$store.dispatch("ProductData/setSectorsDisplayData", []);
        view.$store.dispatch("ProductData/setSectorsSubmittable", []);
      }
      view.toggle_sector_divs = view.$utils.newSectorsDivToggles(
        view,
        view.toggle_sector_divs
      );
      if (
        view.$utils.checkFirstSectorIsCreditCard(view, pc.sector.credit_card) &&
        view.$store.getters["ProductData/getProductName"] == ""
      ) {
        view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please add product name!",
        });
      }
      view.$utils.checkIfAllPromotionsSectorsExists(view);
      // set insaurance exchange in offer origin if any company have insurance exchange and any sector category has health insurance
      if (
        view.$utils.checkIfAnyCompanyInsExchange(view) &&
        view.$utils.checkIfSectorIndexExist(
          view,
          view.$c.category.health_insurance,
          1
        )
      ) {
        view.$store.dispatch("ProductData/setOfferOrigin", 4);
      }
      //set worksite volantury
      if (view.$utils.checkIfAnySectorWorksiteVoluntary(view)) {
        view.$store.dispatch("ProductData/setWorksiteVoluntary", true);
      }
      //
    },
    checkFutureDate() {
      let currentDate = new Date().toISOString().slice(0, 10);
      this.panelists.forEach((item) => {
        if (!this.futureDateSelected)
          this.futureDateSelected =
            item.pp_date.slice(0, 10).trim() > currentDate.trim()
              ? true
              : false;
      });
    },
    editFutureDate() {
      this.futureDateSelected = false;
      this.checkFutureDate();
    },
    panelistStrFormat: function (o) {
      var str = "";
      this.checkFutureDate();
      if (o.competi_id !== null) {
        // competi_id
        str = str + o.competi_id;
      }
      if (o.first_name !== undefined || o.last_name !== undefined) {
        str = str + ` [ ${o.first_name} ${o.last_name} ]`;
      }
      if (o.name !== undefined) {
        str = str + ` [ ${o.name} ]`;
      }
      if (typeof o.invitation_id !== "undefined" && o.invitation_id !== "") {
        // invitation id
        str = str + " [ " + o.invitation_id + " ] ";
      }
      if (typeof o.tracking_id !== "undefined" && o.tracking_id !== "") {
        // last4digits
        str = str + " { " + o.tracking_id + " } ";
      }
      str =
        str +
        " ( " +
        moment(o.pp_date).format("YYYY/MM/DD").toUpperCase() +
        " ) ";

      let state_code = "";
      state_code = this.state_abb(o);
      if (state_code != "") {
        str = str + " / " + state_code;
      }
      return str;
    },
    state_abb: function (p) {
      let state_name = "";
      let raw_states = this.$store.getters["ProductData/getRawProductStates"];
      if (raw_states.length) {
        raw_states.forEach((rs) => {
          if (rs.stateID == p.stateID) {
            state_name = rs.stateCode;
          }
        });
      }
      return state_name;
    },
    removePanelist: function (p) {
      this.$store.dispatch("ProductData/removePanelist", p);
      let selected_panelists = this.$store.getters["ProductData/getPanelists"];
      let panelists_have_same_state = [];
      let panelists_have_same_age = [];
      let panelists_have_same_income = [];
      let males = [];
      let females = [];
      if (selected_panelists.length) {
        selected_panelists.forEach((o) => {
          // gender
          if (o.gender != "") {
            if (o.gender == "M") {
              males.push(1);
            } else {
              females.push(1);
            }
          }

          // state
          if (o.stateID == p.stateID) {
            panelists_have_same_state.push(1);
          }
          // age
          if (o.age == p.age) {
            panelists_have_same_age.push(1);
          }
          // state
          if (o.incomeID == p.incomeID) {
            panelists_have_same_income.push(1);
          }
        });

        // set gender accordingly

        if (males.length > 0 && females.length > 0) {
          this.$store.dispatch("ProductData/setGender", "");
          this.$store.dispatch("ProductData/setGender", "B");
        } else if (males.length > 0) {
          this.$store.dispatch("ProductData/setGender", "");
          this.$store.dispatch("ProductData/setGender", "M");
        } else if (females.length > 0) {
          this.$store.dispatch("ProductData/setGender", "");
          this.$store.dispatch("ProductData/setGender", "F");
        } else {
          this.$store.dispatch("ProductData/setGender", "N");
        }

        // set age accordingly
        if (panelists_have_same_age.length == 0) {
          let product_age = this.$store.getters["ProductData/getProductAge"];
          let new_product_age = product_age.filter((a) => a != p.age);
          this.$store.dispatch("ProductData/setProductAge", new_product_age);
        }

        // set income accordingly
        if (panelists_have_same_income.length == 0) {
          let product_income =
            this.$store.getters["ProductData/getProductIncome"];
          let new_product_income = product_income.filter(
            (i) => i != p.incomeID
          );
          this.$store.dispatch(
            "ProductData/setProductIncome",
            new_product_income
          );
        }

        // set state accordingly
        if (panelists_have_same_state.length == 0) {
          let product_states =
            this.$store.getters["ProductData/getStateProvince"];
          let new_product_states = product_states.filter((s) => s != p.stateID);
          // console.log(
          //   "new_product_states",
          //   new_product_states,
          //   p.stateID,
          //   product_states
          // );
          this.$store.dispatch(
            "ProductData/setStateProvince",
            new_product_states
          );
        }
      } else {
        this.$store.dispatch("ProductData/setGender", "N");
        // this.$store.dispatch("ProductData/setStateProvince", []);
        // this.$store.dispatch("ProductData/setProductIncome", []);
        // this.$store.dispatch("ProductData/setProductAge", []);
        //////
        let product_age = this.$store.getters["ProductData/getProductAge"];
        let new_product_age = product_age.filter((a) => a != p.age);
        this.$store.dispatch("ProductData/setProductAge", new_product_age);
        //////////
        let product_income =
          this.$store.getters["ProductData/getProductIncome"];
        let new_product_income = product_income.filter((i) => i != p.incomeID);
        this.$store.dispatch(
          "ProductData/setProductIncome",
          new_product_income
        );
        ////////
        let product_states =
          this.$store.getters["ProductData/getStateProvince"];
        let new_product_states = product_states.filter((s) => s != p.stateID);
        // console.log(
        //   "new_product_states",
        //   new_product_states,
        //   p.stateID,
        //   product_states
        // );
        // PATCH added for JIRAID-3335
        if (product_states != 0) {
          this.$store.dispatch(
            "ProductData/setStateProvince",
            new_product_states
          );
        }
      }
    },
    editPanelist: function (i) {
      this.openPanelist = false;
      if (this.showeditpanelist === false) {
        this.showeditpanelist = true;
        this.editpan_index = i;
      }
    },
    entryDate: function (d) {
      //alert(view.$store.getters['ProductData/getEntryDateChanged'])
      this.$store.dispatch("ProductData/setEntryDateChanged", true);
      //alert(view.$store.getters['ProductData/getEntryDateChanged'])
      this.$store.dispatch("ProductData/setEntryDate", d);
    },
    offerExpiryDate: function (d) {
      let view = this,
        entryDate = new Date(view.$store.getters["ProductData/getEntryDate"]),
        d1 = new Date(d);
      if (entryDate > d1) {
        alert("Offer expiry date shouldn't be older than entry date.");
      }
      view.$store.dispatch("ProductData/setOfferExpiry", d);
    },
    action_sign_on_incentive: function (o) {
      var key = "sign_on_" + o.c;
      this["data"][key][o.key] = o.data;
    },
    closeAddCompany: function (o) {
      this.openAddCompany = o;
    },
    isDisplayedImage: function (i) {
      return this.imgPath(i) !== "" && this.imgPath(i) !== null;
    },
    imgPath: function (i) {
      let d = this.$store.getters["ProductData/getCompanyImageData"],
        arr = [];
      if (Array.isArray(d) && d.length) {
        d.forEach(function (o) {
          if (o.companyID === i.companyID) {
            arr.push(o);
          }
        });
      }
      return arr.length > 0
        ? arr[0].imagePath === null || arr[0].imagePath === ""
          ? ""
          : arr[0].imagePath
        : "";
    },
    showImage: function (c) {
      var view = this;
      //console.log(c);
      view.$store
        .dispatch("ProductData/setCurrentCompanyId", c.companyID)
        .then(function () {
          let path = view.imgPath(c);
          view.$store.dispatch(
            "ProductData/setCurrentCompanyPath",
            path === "" ? "" : path
          );
          view.$store.dispatch(
            "ProductData/setProductImg",
            path === "" ? "" : path
          );
          let stateCompanies = view.$store.getters["ProductData/getCompanies"];
          stateCompanies.forEach((comp) => {
            if (comp.companyID === c.companyID) {
              comp.default_img = 1;
            } else {
              comp.default_img = 0;
            }
          });
          view.$store.dispatch("ProductData/setCompanies", []);
          view.$store.dispatch("ProductData/setCompanies", stateCompanies);
        });
    },
    selectCompany: function (c) {
      let view = this,
        stateCompanies = view.$store.getters["ProductData/getCompanies"],
        dup = stateCompanies.filter((o) => o.companyID === c.companyID);
      view.openAddCompany = false;
      // view.showImage(c);
      if (parseInt(dup.length) === parseInt(0)) {
        stateCompanies.push({
          companyID: c.companyID,
          companyName: c.companyName,
          default_img: 0,
          isWorksiteVoluntary: c.isWorksiteVoluntary,
          isMilitaryCo: c.isMilitaryCo,
          isInsuranceExchange: c.isInsuranceExchange,
          co_states: c.co_states,
        });
      }
      view.$store
        .dispatch("ProductData/setCompanyImageData", {
          companyID: c.companyID,
          imagePath: c.imagePath,
        })
        .then(function () {
          // let path =
          //   c.imagePath === null || c.imagePath === "" ? "" : c.imagePath;
          // view.$store.dispatch(
          //   "ProductData/setCurrentCompanyPath",
          //   path === "" ? "" : view.$c.image_base_url + c.imagePath
          // );
          // view.$store.dispatch("ProductData/setCurrentCompanyId", c.companyID);

          //insert product associative data
          if (c.associatedProductName != null) {
            let all_associated_data =
              view.$store.getters["ProductData/getCompanyAssociatedData"];
            if (all_associated_data.length) {
              all_associated_data.forEach(function (item) {
                if (item.company_id != c.companyID) {
                  all_associated_data.push({
                    company_id: c.companyID,
                    product_names: c.associatedProductName.split("##"),
                  });
                }
              });
              view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
              view.$store.dispatch(
                "ProductData/setCompanyAssociatedData",
                all_associated_data
              );
            } else {
              all_associated_data.push({
                company_id: c.companyID,
                product_names: c.associatedProductName.split("##"),
              });
              view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
              view.$store.dispatch(
                "ProductData/setCompanyAssociatedData",
                all_associated_data
              );
            }
          }
          ///////

          view.toggle_sector_divs = view.$utils.newSectorsDivToggles(
            view,
            view.toggle_sector_divs
          );
          if (view.$store.getters["ProductData/getCompanies"].length) {
            let sectorsData = view.$store.getters["ProductData/getSector"];
            if (
              (view.media_channel === 5 ||
                view.media_channel === 10 ||
                view.media_channel === 9) &&
              sectorsData.length
            ) {
              view.populateHeadline();
            }
          }
          //set worksite volantury
          if (view.$utils.checkIfAnyCompanyWorksiteVoluntary(view)) {
            view.$store.dispatch("ProductData/setWorksiteVoluntary", true);
          }
          //
          // set military option in target market

          if (view.$utils.checkIfAnyCompanyMilitary(view)) {
            let stateTargetMarket =
              view.$store.getters["ProductData/getTargetMarket"];
            if (!stateTargetMarket.includes(13)) {
              stateTargetMarket.push(13);
            }
            view.$store.dispatch("ProductData/setTargetMarket", []);
            view.$store.dispatch(
              "ProductData/setTargetMarket",
              stateTargetMarket
            );
          }
          // set insaurance exchange in offer origin if any company have insurance exchange and any sector category has health insurance
          if (
            view.$utils.checkIfAnyCompanyInsExchange(view) &&
            view.$utils.checkIfSectorIndexExist(
              view,
              view.$c.category.health_insurance,
              1
            )
          ) {
            view.$store.dispatch("ProductData/setOfferOrigin", 4);
          }
        });
    },

    traverseCompanies: function (o, order) {
      let view = this;
      var companies = this.$store.getters["ProductData/getCompanies"],
        index = _.findIndex(companies, function (i) {
          return i.companyID === o.companyID;
        }),
        toObjOrder =
          order === true
            ? parseInt(index) - parseInt(1)
            : parseInt(index) + parseInt(1),
        thisObj = o,
        thisObjOrder = index,
        toObj = companies[toObjOrder];

      if (
        typeof companies[thisObjOrder] === "undefined" ||
        typeof companies[toObjOrder] === "undefined"
      ) {
        return;
      }
      companies[thisObjOrder] = toObj;
      companies[toObjOrder] = thisObj;
      this.$store.dispatch("ProductData/setCompanies", []);
      this.$store.dispatch("ProductData/setCompanies", companies);
      view.toggle_sector_divs = view.$utils.newSectorsDivToggles(
        view,
        view.toggle_sector_divs
      );
      if (view.$store.getters["ProductData/getCompanies"].length) {
        if (view.isDigitalMediaChannel()) {
          view.populateHeadline();
        }
      }
    },
    removeCompany: function (i) {
      let view = this;
      let stateCompanies = this.$store.getters["ProductData/getCompanies"];
      let newCompanies = stateCompanies.filter(
        (o) => o.companyID !== i.companyID
      );
      this.$store.dispatch("ProductData/setCompanies", newCompanies);

      if (view.$store.getters["ProductData/getCompanies"].length == 0) {
        if (view.isDigitalMediaChannel()) {
          view.$store.dispatch("ProductData/setProductHeadline", "");
        }
      } else {
        if (this.isDigitalMediaChannel()) {
          this.populateHeadline();
        }
      }

      view.$utils.checkIfAllPromotionsCompanyExists(view);

      view.toggle_sector_divs = view.$utils.newSectorsDivToggles(
        view,
        view.toggle_sector_divs
      );
      //remove product associative data
      let all_associated_data =
        view.$store.getters["ProductData/getCompanyAssociatedData"];
      if (all_associated_data.length) {
        let newCompanyAssociativeData = all_associated_data.filter(
          (o) => o.company_id !== i.companyID
        );
        view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
        view.$store.dispatch(
          "ProductData/setCompanyAssociatedData",
          newCompanyAssociativeData
        );
      }

      if (newCompanies.length == 0) {
        view.$store.dispatch("ProductData/setCompanyAssociatedData", []);
        view.$store.dispatch("ProductData/setCurrentCompanyPath", "");
        view.$store.dispatch("ProductData/setProductImg", "");
        view.$store.dispatch("ProductData/setCurrentCompanyId", "");
      }

      //set worksite volantury
      if (view.$utils.checkIfAnyCompanyWorksiteVoluntary(view)) {
        view.$store.dispatch("ProductData/setWorksiteVoluntary", true);
      }
      // set military option in target market

      if (view.$utils.checkIfAnyCompanyMilitary(view)) {
        let stateTargetMarket =
          view.$store.getters["ProductData/getTargetMarket"];
        if (!stateTargetMarket.includes(13)) {
          stateTargetMarket.push(13);
        }
        view.$store.dispatch("ProductData/setTargetMarket", []);
        view.$store.dispatch("ProductData/setTargetMarket", stateTargetMarket);
      }
      // set insaurance exchange in offer origin if any company have insurance exchange and any sector category has health insurance
      if (
        view.$utils.checkIfAnyCompanyInsExchange(view) &&
        view.$utils.checkIfSectorIndexExist(
          view,
          view.$c.category.health_insurance,
          1
        )
      ) {
        view.$store.dispatch("ProductData/setOfferOrigin", 4);
      }
      //
    },
    removeAffinity: function (i) {
      let stateAffinity = this.$store.getters["ProductData/getAffinity"];
      let newAffinity = stateAffinity.filter((o) => o.affinityID !== i);
      this.$store.dispatch("ProductData/setAffinity", newAffinity);
    },
    submit: function () {
      var view = this,
        validationMsg = view.$utils.validateProduct(view);
      let state_specific = view.$store.getters["ProductData/getStateSpecific"];
      let selected_states = view.$store.getters["ProductData/getStateProvince"];
      let entry_date = view.$store.getters["ProductData/getEntryDate"];
      let panelists = view.$store.getters["ProductData/getPanelists"];
      let offer_expiry_date = view.$store.getters["ProductData/getOfferExpiry"];
      view.btnClick = "submit";
      const minDate = new Date(
        Math.min(
          ...panelists.map((element) => {
            return new Date(element.pp_date);
          })
        )
      );

      if (state_specific && selected_states.length > 1) {
        view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title:
            "Panelist of different states are not allowed when state specific is checked!",
        });
      } else if (
        Date.parse(moment(offer_expiry_date).format("YYYY-MM-DD")) <
        Date.parse(moment(entry_date).format("YYYY-MM-DD"))
      ) {
        this.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title:
            "Offer Expiry date " +
            moment(offer_expiry_date).format("YYYY-MM-DD") +
            " cannot be older than Entry Date " +
            moment(entry_date).format("YYYY-MM-DD"),
        });
        return false;
      } else if (
        Date.parse(moment(minDate).format("YYYY-MM-DD")) <
        Date.parse(moment(entry_date).format("YYYY-MM-DD"))
      ) {
        this.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title:
            "Panelist date " +
            moment(minDate).format("YYYY-MM-DD") +
            " cannot be older than Entry Date " +
            moment(entry_date).format("YYYY-MM-DD"),
        });
        return false;
      } else if (Array.isArray(validationMsg) && validationMsg.length) {
        view.confirm_submit = true;
        view.confirm_submit_text = validationMsg;
      } else {
        view.send();
      }
    },

    uploadPdf: function () {
      var view = this;
      let current_active_module =
        view.$store.getters["RawData/getCurrentActiveModule"];
      let user_id = view.$utils.getCookies("user_id");

      // upload product pdf
      let pformdata = view.$utils.filterProductData(view);
      let token = view.$utils.getAccessToken();
      pformdata = JSON.parse(pformdata);
      let formData = new FormData();
      let pdf_content_text = pformdata.pdf_content;
      let file_size = this.product_pdf == null ? "" : this.product_pdf.size;
      formData.append("pdf_destination", view.pdf_destination);
      formData.append("img_destination", view.img_destination);
      formData.append("file_size", file_size);
      // formData.append("product_pdf", view.product_pdf);
      formData.append("product_media", view.product_media);
      formData.append("product_id", view.after_submit_msg.product_id);
      formData.append("muid", pformdata.muid);
      formData.append("userid", pformdata.userid);
      formData.append("doucment_created_by", pformdata.userid);
      formData.append("use_same_process_pdf", view.use_same_process_pdf);
      formData.append("pdf_content", pdf_content_text);
      formData.append("pformdata", view.$utils.filterProductData(view));
      formData.append("img_files", view.img_files);
      formData.append("file_name", view.uploaded_pdf_filename);
      formData.append("media_channel", view.media_channel);
      var endPoint = view.$url("UPLOAD_PRODUCT_PDF");
      //var endPoint = "http://0.0.0.0:5054/uploadpdf";

      return axios.post(endPoint, formData, {
        headers: {
          moduleid: current_active_module,
          userid: user_id,
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
      });
    },
    send: function () {
      var view = this;
      let selected_states = view.$store.getters["ProductData/getStateProvince"];
      if (
        view.checkStateSpecifcCompanyOrNot(selected_states) &&
        view.companies_state_species
      ) {
        view.companies_state_modal = true;
      } else {
        view.confirm_submit = false;
        this.isLoading = true;
        if (view.product_pdf != null) {
          view.$store.dispatch("ProductData/setIsMobileProduct", 1);
        }

        //let show_preview = true;

        view
          .$fetch(
            {
              //url: "http://0.0.0.0:5054/addProduct",
              url: view.$url("API") + "addProduct",
              type: "POST",
              data: view.$utils.filterProductData(view),
              contentType: "application/json",
            },
            {
              operation: "add",
              vueScope: view,
            }
          )
          .then(function (r) {
            if (r.statusCode === 200) {
              view.after_submit_msg = r.payload;
              view.$store.dispatch(
                "ProductData/setProductId",
                view.after_submit_msg.product_id
              );
              if (view.$route.name != "product-v2") {
                view.uploadPdf().then(function () {
                  view.after_submit_msg = r.payload;
                  view.isLoading = false;
                  view.after_submit = true;
                  view.upload_button_click = false;
                });
              } else {
                view.after_submit = true;
                view.isLoading = false;
              }
            }
          })

          .catch(function (e) {
            console.log(e);
            view.isLoading = false;
            view.$swal.fire({
              position: "bottom-end",
              icon: "error",
              title: e.responseJSON.payload.msg,
            });
          });
      }
    },
    reprocessed: function () {
      var view = this;
      if (!view.futureDateSelected) {
        view.file_upload_msg = "";
        view.confirm_submit_text_approved = "";
        var validationMsg = view.$utils.validateProduct(view);
        //view.$store.dispatch('ProductData/setProductStatus',4)
        let state_specific =
          view.$store.getters["ProductData/getStateSpecific"];
        let selected_states =
          view.$store.getters["ProductData/getStateProvince"];
        // PATCH added for JIRAID-3335
        let entry_date = view.$store.getters["ProductData/getEntryDate"];
        let panelists = view.$store.getters["ProductData/getPanelists"];
        let offer_expiry_date =
          view.$store.getters["ProductData/getOfferExpiry"];
        view.btnClick = "reprocessed";
        const minDate = new Date(
          Math.min(
            ...panelists.map((element) => {
              return new Date(element.pp_date);
            })
          )
        );
        if (state_specific && this.checkDiff(selected_states)) {
          view.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Panelist of different states are not allowed when state specific is checked!",
          });
        } else if (
          Date.parse(moment(offer_expiry_date).format("YYYY-MM-DD")) <
          Date.parse(moment(entry_date).format("YYYY-MM-DD"))
        ) {
          this.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Offer Expiry date " +
              moment(offer_expiry_date).format("YYYY-MM-DD") +
              " cannot be older than Entry Date " +
              moment(entry_date).format("YYYY-MM-DD"),
          });
          return false;
        } else if (
          Date.parse(moment(minDate).format("YYYY-MM-DD")) <
          Date.parse(moment(entry_date).format("YYYY-MM-DD"))
        ) {
          this.$swal.fire({
            position: "bottom-end",
            icon: "error",
            title:
              "Panelist date " +
              moment(minDate).format("YYYY-MM-DD") +
              " cannot be older than Entry Date " +
              moment(entry_date).format("YYYY-MM-DD"),
          });
          return false;
        } else if (Array.isArray(validationMsg) && validationMsg.length) {
          view.confirm_submit = true;
          view.confirm_submit_text = validationMsg;
        } else {
          if (view.product_pdf != null) {
            if (view.uploaded_pdf_filename == "") {
              view.$swal.fire({
                position: "bottom-end",
                icon: "error",
                title:
                  "File not uploaded.Please click upload button to upload file ",
              });
            } else {
              view.$store.dispatch("ProductData/setProductStatus", 3);
              this.send();
            }
          } else {
            view.$store.dispatch("ProductData/setProductStatus", 3);
            this.send();
          }
        }
        // var view = this
        // let url = (view.content_type == 'direct')?view.$url("DIRECT_MAIL_TEMP_GRIP"):view.$url("TEMP_PRODUCT_LISTING")
        // window.location.href = url;
      } else {
        view.$swal.fire({
          position: "center",
          title: "Invalid date: Panelist date cannot be in the future.",

          icon: "error",
        });
      }
    },
    set_variant_entry_id: function (d) {
      this.$store.dispatch("ProductData/setVarientEntryId", d);
    },
    addSectorCombination: function (mode, i) {
      let view = this;
      if (this.isDigitalMediaChannel() && this.companies.length == 0) {
        view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please add companies!",
        });
        return false;
      }
      if (view.watchsectors == "" || view.watchcategory == "") {
        view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please select Sector and Category!",
        });
        return false;
      }
      //  console.log(view.$utils.checkIfSectorIndexExist(view,view.watchsectors,0),view.$utils.checkIfSectorIndexExist(view,view.watchcategory,1),view.$utils.checkIfSectorIndexExist(view,view.watchsubcategory,2),view.$utils.checkIfSectorIndexExist(view,view.watchsubsubcategory,3));
      let newCombinationIds = [view.watchsectors, view.watchcategory];
      if (view.watchsubcategory != "") {
        newCombinationIds.push(view.watchsubcategory);
      }
      if (view.watchsubsubcategory != "") {
        newCombinationIds.push(view.watchsubsubcategory);
      }
      if (view.$utils.checkIfSectorCombinationExist(view, newCombinationIds)) {
        view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title:
            "Selected sector/category/subcategory combination already exist!",
        });
        return false;
      }
      // if (
      //   view.$utils.checkIfSectorIndexExist(view, view.watchsectors, 0) &&
      //   view.$utils.checkIfSectorIndexExist(view, view.watchcategory, 1) &&
      //   (view.$utils.checkIfSectorIndexExist(view, view.watchsubcategory, 2) ||
      //     view.watchsubcategory == "") &&
      //   (view.$utils.checkIfSectorIndexExist(
      //     view,
      //     view.watchsubsubcategory,
      //     3
      //   ) ||
      //     view.watchsubsubcategory == "")
      // ) {
      //   view.$swal.fire({
      //     position: "bottom-end",
      //     icon: "error",
      //     title:
      //       "Selected sector/category/subcategory combination already exist!",
      //   });
      //   return false;
      // }

      let newCombination = [],
        sectorsData = view.$store.getters["ProductData/getSector"];
      //sector
      let sector = view.watchsectors,
        sectorName = view.$utils.getSectorName(view, sector),
        sectorWorksiteVoluntary = view.$utils.getSectorWorksiteVoluntay(
          view,
          sector,
          1
        ),
        newSector = {
          id: sector,
          name: sectorName,
          sequence: sectorsData.length + 1,
          sectorWorksiteVoluntary: sectorWorksiteVoluntary,
        };
      newCombination.push(newSector);
      // category
      let category = view.watchcategory,
        categoryName = view.$utils.getCategoryName(view, category),
        categoryWorksiteVoluntary = view.$utils.getSectorWorksiteVoluntay(
          view,
          category,
          2
        ),
        newCategory = {
          id: category,
          name: categoryName,
          sequence_no: sectorsData.length + 1,
          sectorWorksiteVoluntary: categoryWorksiteVoluntary,
        };
      newCombination.push(newCategory);
      //subcategory
      let subcategory = view.watchsubcategory;
      if (subcategory != "") {
        let subcategoryName = view.$utils.getsubcategoryName(view, subcategory),
          subcategoryWorksiteVoluntary = view.$utils.getSectorWorksiteVoluntay(
            view,
            subcategory,
            3
          ),
          newsubcategory = {
            id: subcategory,
            name: subcategoryName,
            sequence_no: sectorsData.length + 1,
            sectorWorksiteVoluntary: subcategoryWorksiteVoluntary,
          };
        newCombination.push(newsubcategory);
      }
      //subsubcategory
      let subsubcategory = view.watchsubsubcategory;
      if (subsubcategory != "") {
        let subsubcategoryName = view.$utils.getsubsubcategoryName(
          view,
          subsubcategory
        );
        let subsubcategoryWorksiteVoluntary =
          view.$utils.getSectorWorksiteVoluntay(view, subsubcategory, 4);
        let newsubsubcategory = {
          id: subsubcategory,
          name: subsubcategoryName,
          sequence_no: sectorsData.length + 1,
          sectorWorksiteVoluntary: subsubcategoryWorksiteVoluntary,
        };
        newCombination.push(newsubsubcategory);
      }
      mode == "add"
        ? sectorsData.push(newCombination)
        : sectorsData.splice(i, 0, newCombination);
      this.updateSubmittableSectors(sectorsData);
      if (this.isDigitalMediaChannel()) {
        this.populateHeadline();
      }
      view.watchsectors = "";
      view.watchcategory = "";
      view.watchsubcategory = "";
      view.watchsubsubcategory = "";
    },
    removeSectorCombination: function (i) {
      let view = this,
        sectorsData = view.$store.getters["ProductData/getSector"];
      if (sectorsData.length == 1) {
        if (view.editSectorMode === true) {
          sectorsData = [];
          view.updateSubmittableSectors(sectorsData);
        } else {
          view.$swal
            .fire({
              title: "Are you sure ?",
              text: "This will clear all Sector/Category/Sub-category dependant fields.",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, remove it !",
              cancelButtonText: "No, cancel !",
              closeOnConfirm: false,
              closeOnCancel: false,
            })
            .then((result) => {
              if (result.isConfirmed) {
                sectorsData = [];
                view.updateSubmittableSectors(sectorsData);
                if (view.isDigitalMediaChannel()) {
                  view.$store.dispatch("ProductData/setProductHeadline", "");
                }
              } else if (result.isDenied) {
                view.$swal.fire(
                  "Cancelled",
                  "Sector/Category/Sub-Category Combination was not removed !",
                  "error"
                );
              }
            });
        }
      } else {
        if (i > -1) {
          sectorsData.splice(i, 1);
          //console.log(i);
        }
        view.updateSubmittableSectors(sectorsData);
        if (this.isDigitalMediaChannel()) {
          this.populateHeadline();
        }
      }

      //view.sectorsData = sectorsData
    },
    traverseSectorCombinations: function (i, order) {
      var sectorsData = this.$store.getters["ProductData/getSector"],
        // index = _.findIndex(companies, function(i) {
        //     return i.companyID === o.companyID
        // }),
        toObjOrder =
          order === true
            ? parseInt(i) - parseInt(1)
            : parseInt(i) + parseInt(1),
        thisObj = sectorsData[i],
        thisObjOrder = i,
        toObj = sectorsData[toObjOrder];
      if (
        typeof sectorsData[thisObjOrder] === "undefined" ||
        typeof sectorsData[toObjOrder] === "undefined"
      ) {
        return;
      }
      sectorsData[thisObjOrder] = toObj;
      sectorsData[toObjOrder] = thisObj;

      //this.sectorsData = []
      //this.sectorsData = sectorsData
      this.updateSubmittableSectors(sectorsData);
      if (this.isDigitalMediaChannel()) {
        this.populateHeadline();
      }
      // this.$store.dispatch('ProductData/setCompanies', [])
      // this.$store.dispatch('ProductData/setCompanies', companies)
    },
    editSectorCombination: function (i) {
      let view = this;
      view.editSectorCombinationIndex = i;
      view.editSectorMode = true;
      let sectorsData = this.$store.getters["ProductData/getSector"];
      let thisObj = sectorsData[i];
      view.watchsectors = thisObj[0].id;
      view.watchcategory = thisObj[1].id;
      if (thisObj[2] != undefined) {
        view.watchsubcategory = thisObj[2].id;
      }
      if (thisObj[3] != undefined) {
        view.watchsubsubcategory = thisObj[3].id;
      }
      view.$utils
        .setCategory(view)
        .then(view.$utils.setSubCategory(view))
        .then(view.$utils.setSubSubCategory(view))
        .then(() => {
          view.watchcategory = thisObj[1].id;
          if (thisObj[2] != undefined) {
            view.watchsubcategory = thisObj[2].id;
          }
          if (thisObj[3] != undefined) {
            view.watchsubsubcategory = thisObj[3].id;
          }
        });
    },
    updateSectorCombination: function (i) {
      let view = this;
      if (view.watchsectors == "" || view.watchcategory == "") {
        view.$swal.fire({
          position: "bottom-end",
          icon: "error",
          title: "Please select Sector and Category!",
          showConfirmButton: false,
          timer: 2500,
        });
        return false;
      }
      view.removeSectorCombination(i);
      view.addSectorCombination("update", i);
      view.editSectorCombinationIndex = "";
      view.editSectorMode = false;
      view.watchsectors = "";
      view.watchcategory = "";
      view.watchsubcategory = "";
      view.watchsubsubcategory = "";
    },
    removePublication: function (i) {
      //let all_publications = this.$store.getters["ProductData/getPublications"];
      // if (i > -1) {
      //   all_publications.splice(i, 1);
      // }
      // let newPublications = all_publications.filter(
      //   (o) => o.companyID !== i.companyID
      // );
      // this.$store.dispatch("ProductData/setCompanies", newCompanies);
      this.$store.dispatch("ProductData/removePublication", i);
    },
    isBonusContentIncentive: function () {
      return this.communication_type.includes(
        this.$c.communication_type.business_content_incentive
      );
    },
    con1: function () {
      return this.$productutils.condition1(this);
    },
    handleToggleSuggestion(val){
      if(!val){
        this.suggestionText=''
      }
    },
    copySuggestion(){
      navigator.clipboard?.writeText(this.suggestionText)
        .then(() => {
          this.suggestionText=''
        })
        .catch(err => {
          console.error('Failed to copy text: ', err);
        });
    },
async fetchDmSourceFilename() {
  try {
    const product_id = this.product_id;
    if (!product_id) return;

    const url = this.$url("DMTM_FILENAME");

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        product_id,
      },
    });

    if (response.status === 200 && response.data?.data?.filename) {
      const filename = response.data.data.filename;
      this.dmSourceFilename = filename;

      this.dm_tm_source = filename;
    } else {
      this.dmSourceFilename = "";
    }

  } catch (error) {
    console.error("Error fetching DM Source Filename:", error);
    this.dmSourceFilename = "";
  }
},

    // displayFauxCheck: function() {
    //   let view = this,
    //     sectots = view.$store.getters['ProductData/getSubmittableSectors'],
    //     $c = view.$c.sector,
    //     sec = [$c.investment_annulities, $c.automotive, $c.retail_consumer]
    //   if (sectots.length === 1) {
    //     return !sec.includes(sectots[0][0])
    //   } else if (sectots.length === 2) {
    //     return !(sec.includes(sectots[0][0]) && sec.includes(sectots[1][0]))
    //   } else if (sectots.length === 3) {
    //     return !(sec.includes(sectots[0][0]) && sec.includes(sectots[1][0]) && sec.includes(sectots[2][0]))
    //   } else if (sectots.length === 0) {
    //     return false
    //   }
    //   return true
    // }
  },
  watch: {
    panelistDate() {
      this.checkPanelistDate();
    },
    "$store.state.RawData.current_active_module": function (o) {
      if (o) {
        var view = this;
        if (
          view.$route.name == "addproduct" ||
          view.$route.name == "addproduct-v2"
        )
          view.product_id = view.$route.params.muid;
        else view.muid = view.$route.params.muid;

        if (
          (view.muid !== undefined && view.muid != "") ||
          (view.product_id !== undefined && view.product_id != "")
        ) {
          this.$refs.topProgress.start();
        }

        let content_type = "";
        if (view.$route.query.ec_content_type === undefined) {
          if (view.muid === undefined) {
            content_type = "newproduct";
          } else {
            if (view.muid == "" && view.$route.query.channel_id !== undefined) {
              content_type = "newproduct";
            } else {
              content_type = "";
            }
          }
          view.show_pdf_product_row = true;
        } else if (view.$route.query.ec_content_type !== undefined) {
          content_type = view.$route.query.ec_content_type;
        }
        //let content_type = view.$route.query.ec_content_type === undefined?"":view.$route.query.ec_content_type

        view.$store.dispatch("ProductData/setEcContentType", content_type);
        view.content_type = content_type;
        // view.$store.dispatch("ProductData/setEcContentType", "manual");
        if (
          parseInt(view.$route.query.channel_id) == 1 ||
          view.$route.query.ec_content_type == "direct"
        ) {
          view.toggle_sector_divs.handwriting = true;
          view.toggle_sector_divs.tip_on_card = true;
        }
        if (parseInt(view.$route.query.channel_id) == 3) {
          view.$store.dispatch("ProductData/setEcContentType", "manual");
        }
        if (parseInt(view.$route.query.channel_id) == 5) {
          view.show_pdf_product_row = true;
        }

        if (view.content_type == "mobiledigital") {
          if (parseInt(view.$route.query.product_status) == 11)
            view.show_pdf_product_row = false;

          //call an external EP for that
          // let endpoint_url =
          //   this.$url("VIEW_PDF_IMAGES") +
          //   "?product_id=" +
          //   this.product_id +
          //   "&product_type=MobileProduct&product_status=" +
          //   this.$route.query.product_status +
          //   "&checkbannerprod=1";
          //this.check_banner_product(this, endpoint_url);

          //this.get_mobile_digital();
        } else {
          view.show_pdf_product_row = true;
        }

        view.$utils.productRawData(view).then(() => {
          if (view.muid !== undefined) {
            //company prediction
            // if(view.content_type == 'mobiledigital'){
            // }
            //view.$utils.sec_company_pred(view);
            view.$store.dispatch("ProductData/setMuid", view.muid);

            // product historical data endpoints
            //refer JIRA ID:1844
            // if IMO product no need to get product entries
            if (view.$route.query.channel_id === undefined) {
              let route_name = view.$route.name;
              //console.log("indexxx", route_name.indexOf("v2"), route_name);
              if (route_name.indexOf("v2") === -1) {
                view.$utils.fetchHistoricalData(view).then(() => {
                  if (
                    view.$route.query.ec_content_type === undefined ||
                    view.$route.query.ec_content_type == "email"
                  ) {
                    view
                      .$fetch(
                        {
                          url:
                            view.$url("EMAIL") +
                            "/" +
                            view.$store.getters["ProductData/getMuid"],
                          type: "GET",
                        },
                        {
                          operation: "view",
                          vueScope: view,
                        }
                      )
                      .then((response) => {
                        // view.$Progress.increase(20)
                        if (typeof response.email_subject !== "undefined") {
                          view.email_subject = response.email_subject.replace(
                            /\\/g,
                            ""
                          );
                          if (response.deleted !== "undefined") {
                            if (parseInt(response.deleted) === parseInt(1)) {
                              view.update_type = true;
                            }
                          }
                        }
                        if (typeof response.index_name !== "undefined") {
                          view.$store.dispatch(
                            "ProductData/setIndexName",
                            response.index_name
                          );
                        }
                      })
                      .catch((e) => console.log(e));
                  }
                  //console.log("hello");
                });
              } else {
                view = this;
                view.$utils.fetchHistoricalDataV2(view).then(() => {
                  if (
                    !view.product_headline &&
                    view.$route.query.ec_content_type === "direct" &&
                    parseInt(view.product_status) === 5
                  ) {
                    view.headline_loader = true;
                    view
                      .$fetch(
                        {
                          url:
                            view.$url("HEADLINE_PRIDICT") +
                            view.$store.getters["ProductData/getProductId"],
                          type: "GET",
                        },
                        {
                          operation: "view",
                          vueScope: view,
                        }
                      )
                      .then((response) => {
                        view.product_headline = response.headline;
                        view.headline_loader = false;
                      })
                      .catch((e) => console.log(e));
                  }

                  if (
                    view.$route.query.ec_content_type === undefined ||
                    view.$route.query.ec_content_type == "email"
                  ) {
                    view
                      .$fetch(
                        {
                          url:
                            view.$url("EMAIL") +
                            "/" +
                            view.$store.getters["ProductData/getMuid"],
                          type: "GET",
                        },
                        {
                          operation: "view",
                          vueScope: view,
                        }
                      )
                      .then((response) => {
                        // view.$Progress.increase(20)
                        if (typeof response.email_subject !== "undefined") {
                          view.email_subject = response.email_subject.replace(
                            /\\/g,
                            ""
                          );
                          if (response.deleted !== "undefined") {
                            if (parseInt(response.deleted) === parseInt(1)) {
                              view.update_type = true;
                            }
                          }
                        }
                        if (typeof response.index_name !== "undefined") {
                          view.$store.dispatch(
                            "ProductData/setIndexName",
                            response.index_name
                          );
                        }
                      })
                      .catch((e) => console.log(e));
                    //console.log("hello");
                  }
                });
              }
            }
          }

          //end of code
        });

        // view.$utils.sec_pred(view)
        // view.$utils.cat_pred(view)
        // view.$utils.mailing_type_pred(view)

        view.$store.dispatch(
          "ProductData/setUserid",
          view.$utils.getCookies("username").replace(/['"]+/g, "")
        );
        // code added for managing add product route
        this.isAddProduct =
          view.$route.name == "addproduct" ||
          view.$route.name == "addproduct-v2"
            ? true
            : false;
        this.newproduct =
          view.$route.name == "product" || view.$route.name == "product-v2"
            ? true
            : false;

        if (this.isAddProduct && view.$route.query.ec_content_type == "uxmedia")
          view.getUXmedia(view.product_id);
      }
    },
    "$store.state.ProductData.data.sectors": function (o) {
      if (o) {
        let view = this;
        if (view.$route.name.indexOf("v2") === -1) {
          view.$utils.sectorRawdataAudienceDependantEndpoints(this);
        }

        let state_sectors =
          this.$store.getters["ProductData/getSubmittableSectors"];
        let allowed_sectors_ids = [];
        allowed_sectors_ids = view.$store.getters["RawData/getAllowedSectors"];
        let sector_allowed_array = [];
        //console.log("allowed_sectors_ids", allowed_sectors_ids);
        if (state_sectors.length) {
          state_sectors.forEach((s) => {
            //console.log(s[0]);
            if (!allowed_sectors_ids.includes(s[0])) {
              sector_allowed_array.push(s[0]);
            }
            if (s[1] !== undefined) {
              if (!allowed_sectors_ids.includes(s[1])) {
                sector_allowed_array.push(s[1]);
              }
            }
            if (s[2] !== undefined) {
              if (!allowed_sectors_ids.includes(s[2])) {
                sector_allowed_array.push(s[2]);
              }
            }
            if (s[3] !== undefined) {
              if (!allowed_sectors_ids.includes(s[3])) {
                sector_allowed_array.push(s[3]);
              }
            }
          });
        }
        //console.log("sector_allowed_array", sector_allowed_array);
      }
    },
    is_mobile: function (o) {
      var view = this;
      view.show_pdf_product_row = true;
      if (view.$route.query.ec_content_type == "mobiledigital") {
        if (o == 0) view.show_pdf_product_row = false;
        if (parseInt(view.$route.query.product_status) == 11)
          view.show_pdf_product_row = false;
      }
      let file_name = "";
      if (this.mobile_digital_file_url !== undefined)
        file_name =
          this.mobile_digital_file_url.split("/")[this.split("/").length - 1];
      //product_file_ext
      if (file_name != "")
        this.product_file_ext =
          file_name.split(".")[file_name.split(".").length - 1];

      //alert(localStorage.getItem("mobile_digital_image_url"))
      //this.$utils.setCookies("mobile_digital_image_url","skjfsdkfj",this)
      //alert(this.$utils.getCookies("mobile_digital_image_url"))
      //setCookies
      // alert(file_name.split(".")[file_name.split(".").length-1])
    },
    current_pdf: function () {
      let view = this;
      let splitpath =
        view.$store.getters["ProductData/getCurrentPdf"].split("/");
      let pdf_filename = splitpath[splitpath.length - 1];
      view.current_pdf_filename = pdf_filename;
      view.pdf_link =
        view.base_file_path + view.$store.getters["ProductData/getCurrentPdf"];
      if (pdf_filename !== undefined)
        view.current_pdf_product_id = pdf_filename.split("_")[1].split(".")[0];
    },
    watchelectronic_type: function (o) {
      var view = this;
      o.forEach(function (e) {
        view.data.electronic_type.push(e);
      });
      view.data.electronic_type = _.uniq(view.data.electronic_type);
    },
    watchsectors: function (o) {
      var view = this;
      view.watchsectors = o;
      view.watchcategory = "";
      view.watchsubcategory = "";
      view.watchsubsubcategory = "";
      if (o != "") {
        view.$store.dispatch("ProductData/setCategory", []);
        view.$store.dispatch("ProductData/setSubCategory", []);
        view.$store.dispatch("ProductData/setSubSubCategory", []);
        view.$utils.setCategory(view);
      } else {
        view.$store.dispatch("ProductData/setCategory", []);
        view.$store.dispatch("ProductData/setSubCategory", []);
        view.$store.dispatch("ProductData/setSubSubCategory", []);
      }
    },
    watchcategory: function (o) {
      var view = this;
      view.category = o;
      view.watchsubcategory = "";
      view.watchsubsubcategory = "";
      if (o != "") {
        view.$store.dispatch("ProductData/setSubCategory", []);
        view.$store.dispatch("ProductData/setSubSubCategory", []);
        view.$utils.setSubCategory(view);
      } else {
        view.$store.dispatch("ProductData/setSubCategory", []);
        view.$store.dispatch("ProductData/setSubSubCategory", []);
      }
    },
    watchsubcategory: function (o) {
      var view = this;
      view.watchsubcategory = o;
      view.watchsubsubcategory = "";
      if (o != "") {
        view.$store.dispatch("ProductData/setSubSubCategory", []);
        view.$utils.setSubSubCategory(view);
      } else {
        view.$store.dispatch("ProductData/setSubSubCategory", []);
      }
    },
    watchsubsubcategory: function (o) {
      this.watchsubsubcategory = o;
    },
    watch_audience: function (o) {
      this.data.audience = o;
    },
    searchProductNames(val) {
      if (!val || val.length == 0) {
        this.product_names = [];
        return;
      }
      let all_associated_data =
        this.$store.getters["ProductData/getCompanyAssociatedData"];

      let filtered_product_names = [];
      all_associated_data.map(function (o) {
        o.product_names.map(function (name) {
          if (name.toLowerCase().match(val.toLowerCase())) {
            filtered_product_names.push(name);
          }
        });
      });
      if (filtered_product_names.length == 0) {
        filtered_product_names.push("Product Name Not Mentioned");
      }

      this.product_names = filtered_product_names;
    },
  },
};
</script>

<style lang="sass" scoped>
@import './../assets/sass/product/product'
.v-card__title
  font-size: 18px!important
.theme--light.v-data-table.v-data-table--fixed-header thead th
  background: #3f51b5 !important
</style>
<style type="text/css">
.v-data-table-header {
  background-color: #3f51b5 !important;
  border-color: #3f51b5 !important;
}

.v-data-table-header th {
  color: #fff !important;
}

.v-application--wrap {
  min-height: 0vh !important;
}

.theme--light.v-chip:not(.v-chip--active) {
  background: #fff;
}

:not(.v-select).v-text-field input[readonly="readonly"] {
  background-color: #f0f0f0;
  color: gray;
}

#hedlinetextarea:focus {
  outline: none !important;
  /* border-color: #3f51b5; */
  /* box-shadow: 0 0 10px #3f51b5; */
  border: 2px #1976d2 solid !important ;
}

#hedlinetextarea:hover:not(:focus) {
  border: 1px #000 solid !important ;
}

/* The alert message box */
.headlinealert {
  padding: 20px;
  background-color: #81c784; /* Red */
  color: white;
  margin-bottom: 15px;
}

/* The close button */
.closebtn {
  margin-left: 15px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

/* When moving the mouse over the close button */
.closebtn:hover {
  color: black;
}
</style>
